import React, { useState, useEffect, useCallback } from 'react'; // Component, useMemo, useRef, // const { useState, useEffect, useRef } = React; 

import SplitPane from 'react-split-pane'; //, { Pane }
import { Auth } from 'aws-amplify'; //Amplify, { Auth, Hub }
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import CreatableSelect from 'react-select/creatable'; // Creatable, { makeCreatableSelect } 
import Select from 'react-select';
import toast from 'react-hot-toast';
// import XLSX from 'xlsx';
import * as XLSX from 'xlsx';
import IgvVaNex from '../components/IgvVaNex';

// import DropdownButton from 'react-bootstrap/DropdownButton';
// import ButtonGroup from 'react-bootstrap/ButtonGroup';
// import Button from 'react-bootstrap/Button';
import Dropdown from 'react-bootstrap/Dropdown';
// import Modal from 'react-bootstrap/Modal';

import { Modal } from 'bootstrap'; // Collapse, Popover, Toast, Tooltip, Alert, , Dropdown
import { Formik, Form, Field, FieldArray } from 'formik'; //, ErrorMessage
import { Prompt } from 'react-router'; // withRouter

import OmimInfo from "./OmimInfo";
import VariantTable from "./VariantTable";
import VariantInfoBox from "./VariantInfoBox";
import CnvStaticPlotViewer from "./CnvStaticPlotViewer";
import CnvPlotter from "./CnvPlotter/CnvPlotter";
import {GetSignedURL, GetHeatedQualityScore, GetSampleRank, EditableTextArea, VanexNoteCell, 
  VanexTagCell, VanexReviewCell, VanexGenotypeCell, ConstructFilterFunctions, CalcDamagingScores, 
  VanexSegmentSizeCell, VanexArrayCell, VanexMrPhenePhenoTermsCell, VanexMTGenotypeCell,
  sortIntColumn, sortFloatColumn, sortColumnByArrayLength, separateBy1000} from '../HelperFunctions' // VanexMrPhenePhenoTermsCell, 
import IndeterminateCheckbox, {CHECKED, UNCHECKED, INDETERMINATE} from "./IndeterminateCheckbox";

import filterDefinition from '../resources/filters.json';
import pako from 'pako';
import ReviewOptions from '../resources/reviewOptions.json';

import Firefly from '@nch-igm/firefly';


/** props.currentAnalysisInfo
{
  "CASE_ID": "RD0386",
  "ANALYSIS_ID": "2023-07-11T19-02-40_CNV",
  "ANALYSIS_NAME": "2023-07-11",
  "ANALYSIS_NAME_SUFFIX": "2023-07-11T19-02-40",
  "ANALYSIS_TYPE": "CNV",
  "ANALYSIS_NOTE": "",
  "SOURCE_FILE_STATUS": 1,
  "JSON_URI": "s3://nch-igm-vanex/rare_disease/cnv_cases/CASE_ID=RD0386/varscan",
  "PARQUET_URI": "s3://nch-igm-research-rare-disease/2023/RD0386/Churchill/2023-04-06/cnvloh",
  "V_REF": "GRCh38",
  "N_PARQUET_VARIANTS": 0,
  "N_VARIANTS": 0,
  "N_GENES": 0,
  "N_SAMPLES": 3,
  "SAMPLES": [
    {
        "SAMPLE_ID": "RD0386_P_S-2023-009960",
        "SAMPLE_TYPE": "Proband",
        "FILE_URI": "s3://nch-igm-research-rare-disease/2023/RD0386/Churchill/2023-04-06/cnvloh/RD0386_P_S-2023-009960"
    }, {
        "SAMPLE_ID": "RD0386_M_S-2022-025806",
        "SAMPLE_TYPE": "Mother",
        "FILE_URI": "s3://nch-igm-research-rare-disease/2023/RD0386/Churchill/2023-04-06/cnvloh/RD0386_M_S-2022-025806"
    }, {
        "SAMPLE_ID": "RD0386_F_S-2022-025805",
        "SAMPLE_TYPE": "Father",
        "FILE_URI": "s3://nch-igm-research-rare-disease/2023/RD0386/Churchill/2023-04-06/cnvloh/RD0386_F_S-2022-025805"
    }
  ]
}
**/

/** //! duplicated code! is in RdApp too
* @param {Object} object
* @param {string} key
* @return {any} value
*/
const getParameterCaseInsensitive = (object, key) => {
  return object[Object.keys(object)
    .find(k => k.toLowerCase() === key.toLowerCase())
  ];
}

// var request;
// const ENDPOINT_BASE = process.env.REACT_APP_API_URI;



const MTViewer = (props) => {

  //* this controls whether we want the user to change sample types (PMF) during the analysis by showing the button before the column names in the column list
  const showPMFPrefix = false; //!!!! (!!props.currentAnalysisInfo && props.currentAnalysisInfo.ANALYSIS_TYPE && (props.currentAnalysisInfo.ANALYSIS_TYPE==='GermlineSNV' || props.currentAnalysisInfo.ANALYSIS_TYPE==='SomaticSNV')) ? false : true ;
  const [use1000Separator, setUse1000Separator] = useState(true);
  const initialSortBy = [{id:"POS", desc:false}];
  // const [initialSortBy, setInitialSortBy] = useState([{id:"CHROMOSOME", desc:false},{id:"LOC_START", desc:false}]);
  // const [initialSortBy, setInitialSortBy] = useState([{id:"CHROMOSOME", desc:false},{id:"SEG_SIZE", desc:false}]);

  const [initialColumnData, setInitialColumnData] = useState( () => {
    if(!!props.dataColumns)
      return(props.dataColumns);
    if(!!props.caseData && props.caseData.length > 0 && !!props.caseData[0]){
      let columnKeys = new Set(Object.keys(props.caseData[0]));
      props.caseData.forEach(rowData =>{
        columnKeys = new Set([...columnKeys,...Object.keys(rowData)]);
      });
      return( Array.from(columnKeys).map(key => {
        // if(!!props.keepColumnAsIs){
        //   return {
        //     Header: getColumnNameFromAccessor(key),
        //     id: key,
        //     accessor: (dt) => dt[key],
        //     width: 100,
        //     setColWidth: function(inWidth){ this.width = inWidth; }
        //   }
        // }
        if(key==="VANEX_TAGS"){
          return {
            Header: "Tag",
            id: key,
            accessor: (dt) => dt[key],
            width: 10,
            disableResizing: true,
            Cell: VanexTagCell,
            renderDefinedCell: true,
            setColWidth: function(inWidth){ this.width = inWidth; }
          }
        }
        if(key==="VANEX_NOTES"){
          return {
            Header: "Note",
            id: key,
            accessor: (dt) => dt[key],
            width: 200,
            Cell: VanexNoteCell,
            renderDefinedCell: true,
            sortType: (rowA, rowB, columnId, desc) => {
              // if(rowA.values[columnId].CURRENT_USER_NOTE!=="" && !!rowB.values[columnId].CURRENT_USER_NOTE!=="")
                return(rowA.values[columnId].CURRENT_USER_NOTE.localeCompare(rowB.values[columnId].CURRENT_USER_NOTE, undefined, { numeric: true }))
              // if(rowA.values[columnId].CURRENT_USER_NOTE==="" && rowB.values[columnId].CURRENT_USER_NOTE==="") return 100;
              // if(rowA.values[columnId].CURRENT_USER_NOTE==="") return 100;
              // return -100;
            },
            columnStyle: {textAlign: 'center'},
            setColWidth: function(inWidth){ this.width = inWidth; }
          }
        }
        if(key==="VANEX_REVIEWS"){
          return {
            Header: "Review",
            id: key,
            accessor: (dt) => dt[key],
            width: 150,
            Cell: VanexReviewCell,
            renderDefinedCell: true,
            disableResizing: true,
            columnStyle: {textAlign: 'center'},
            style: {overflow :'visible'},
            setColWidth: function(inWidth){ this.width = inWidth; }
          }
        }
        if(key==="MR_PHENE_PHENOTYPE_TERMS"){
          return {
            Header: "MrPhene Pheno. Terms",
            id: key,
            accessor: (dt) => dt[key],
            width: 100,
            sortType: sortColumnByArrayLength,
            // Cell: VanexMrPhenePhenoTermsCell,
            // renderDefinedCell: true,
            columnStyle: {textAlign: 'center'},
            // style: {overflow :'visible'},
            setColWidth: function(inWidth){ this.width = inWidth; }
          }
        }
        if(key==="CHROMOSOME") {
          return {
            Header: "Chr",
            id: key,
            accessor: (dt) => dt[key],
            width: 50,
            sortType: (rowA, rowB, columnId, desc) => {
              let valA = (rowA.values[columnId]==="X" ? 23 : (rowA.values[columnId]==="Y" ? 24 : parseInt(rowA.values[columnId])));
              let valB = (rowB.values[columnId]==="X" ? 23 : (rowB.values[columnId]==="Y" ? 24 : parseInt(rowB.values[columnId])));
              return (valA < valB ? -1 : 1);
              // return (valA < valB ? -1 : (valA > valB ? 1 : 0) );
            },
            style: {fontWeight: 'bolder',textAlign: 'center'},
            // columnStyle: {textAlign: 'center'},
            setColWidth: function(inWidth){ this.width = inWidth; }
          }
        }
        if(key==="POSITION") {
          return {
            Header: "POS",
            id: key,
            accessor: (dt) => dt[key],
            width: 90,
            sortType: sortIntColumn,
            use1000Separator:use1000Separator,
            Cell: (props) => (props.column.use1000Separator ? separateBy1000(props.value) : props.value),
            renderDefinedCell: true,
            // style: {fontWeight: 'bolder',textAlign: 'center'},
            // style: { textAlign: 'center'}, //fontWeight: 'bolder',
            columnStyle: {textAlign: 'center'},
            setColWidth: function(inWidth){ this.width = inWidth; }
          }
        }
        // if(key==="LOC_END") {
        //   return {
        //     Header: "End",
        //     id: key,
        //     accessor: (dt) => dt[key],
        //     width: 90,
        //     sortType: sortIntColumn,
        //     use1000Separator:use1000Separator,
        //     Cell: (props) => (props.column.use1000Separator ? separateBy1000(props.value) : props.value),
        //     renderDefinedCell: true,
        //     // style: {fontWeight: 'bolder',textAlign: 'center'},
        //     // style: { textAlign: 'center'}, //fontWeight: 'bolder',
        //     columnStyle: {textAlign: 'center'},
        //     setColWidth: function(inWidth){ this.width = inWidth; }
        //   }
        // }
        // if(key==="SEG_SIZE") {
        //   return {
        //     Header: "Size",
        //     id: key,
        //     accessor: (dt) => dt[key],
        //     width: 90,
        //     Cell: VanexSegmentSizeCell,
        //     sortType: sortIntColumn,
        //     // style: {fontWeight: 'bolder',textAlign: 'center'},
        //     // style: { textAlign: 'center'}, //fontWeight: 'bolder',
        //     columnStyle: {textAlign: 'center'},
        //     setColWidth: function(inWidth){ this.width = inWidth; }
        //   }
        // }
        // if(key==="CNV_TYPE") {
        //   return {
        //     Header: "Type",
        //     id: key,
        //     accessor: (dt) => dt[key],
        //     width: 50,
        //     useGainLossColor: true,
        //     // style: {fontWeight: 'bolder',textAlign: 'center'},
        //     // style: { textAlign: 'center'}, //fontWeight: 'bolder',
        //     columnStyle: {textAlign: 'center'},
        //     setColWidth: function(inWidth){ this.width = inWidth; }
        //   }
        // }
        // if(key==="SEG_MEAN") {
        //   return {
        //     Header: "Seg Mean",
        //     id: key,
        //     accessor: (dt) => dt[key],
        //     width: 80,
        //     sortType: sortFloatColumn,
        //     Cell: (props) => (  Math.round((Number(props.value) + Number.EPSILON) * 100) / 100 ),
        //     renderDefinedCell: true,
        //     // style: {fontWeight: 'bolder',textAlign: 'center'},
        //     // style: { textAlign: 'center'}, //fontWeight: 'bolder',
        //     columnStyle: {textAlign: 'center'},
        //     setColWidth: function(inWidth){ this.width = inWidth; }
        //   }
        // }
        // if(key==="NUM_MARK") {
        //   return {
        //     Header: "Mark",
        //     id: key,
        //     accessor: (dt) => dt[key],
        //     width: 50,
        //     sortType: sortIntColumn,
        //     // style: {fontWeight: 'bolder',textAlign: 'center'},
        //     // style: { textAlign: 'center'}, //fontWeight: 'bolder',
        //     columnStyle: {textAlign: 'center'},
        //     setColWidth: function(inWidth){ this.width = inWidth; }
        //   }
        // }
        if(key==="ENTREZ_IDS") {
          return {
            Header: "Entrez IDs",
            id: key,
            accessor: (dt) => dt[key],
            width: 100,
            Cell: VanexMrPhenePhenoTermsCell,
            renderDefinedCell: true,
            sortType: sortColumnByArrayLength,
            // style: {fontWeight: 'bolder',textAlign: 'center'},
            // style: { textAlign: 'center'}, //fontWeight: 'bolder',
            columnStyle: {textAlign: 'center'},
            setColWidth: function(inWidth){ this.width = inWidth; },
          }
        }
        if(key==="GENE_SYMBOLS") {
          return {
            Header: "Genes",
            id: key,
            accessor: (dt) => dt[key],
            width: 150,
            Cell: VanexMrPhenePhenoTermsCell,
            renderDefinedCell: true,
            sortType: sortColumnByArrayLength,
            // style: {fontWeight: 'bolder',textAlign: 'center'},
            // style: { textAlign: 'center'}, //fontWeight: 'bolder',
            columnStyle: {textAlign: 'center'},
            setColWidth: function(inWidth){ this.width = inWidth; }
          }
        }
        if(key==="OMIM_PHENOTYPES") {
          return {
            Header: "OMIM Phenotypes",
            id: key,
            accessor: (dt) => dt[key],
            width: 150,
            Cell: VanexArrayCell, //VanexMrPhenePhenoTermsCell,
            renderDefinedCell: true,
            sortType: sortColumnByArrayLength,
            // sortType: (rowA, rowB, columnId, desc) => ( !!rowA.values[columnId] && rowA.values[columnId].length > 0 ? (rowA.values[columnId].length < rowB.values[columnId].length ? -1 : 1) : 0),
            // style: {fontWeight: 'bolder',textAlign: 'center'},
            // style: { textAlign: 'center'}, //fontWeight: 'bolder',
            columnStyle: {textAlign: 'center'},
            setColWidth: function(inWidth){ this.width = inWidth; }
          }
        }
        if(key==="OMIM_INFO") {
          return {
            Header: "OMIM Genes",
            id: key,
            accessor: (dt) => dt[key],
            width: 250,
            // Cell: VanexArrayCell, //VanexMrPhenePhenoTermsCell,
            // renderDefinedCell: true,
            // sortType: sortColumnByArrayLength,
            // sortType: (rowA, rowB, columnId, desc) => ( !!rowA.values[columnId] && rowA.values[columnId].length > 0 ? (rowA.values[columnId].length < rowB.values[columnId].length ? -1 : 1) : 0),
            // style: {fontWeight: 'bolder',textAlign: 'center'},
            // style: { textAlign: 'center'}, //fontWeight: 'bolder',
            columnStyle: {textAlign: 'center'},
            setColWidth: function(inWidth){ this.width = inWidth; }
          }
        }
        // if(key==="MIM_NUMBERS") {
        //   return {
        //     Header: "OMIM Numbers",
        //     id: key,
        //     accessor: (dt) => dt[key],
        //     width: 150,
        //     Cell: VanexArrayCell, //VanexMrPhenePhenoTermsCell,
        //     renderDefinedCell: true,
        //     sortType: sortColumnByArrayLength,
        //     // sortType: (rowA, rowB, columnId, desc) => ( !!rowA.values[columnId] && rowA.values[columnId].length > 0 ? (rowA.values[columnId].length < rowB.values[columnId].length ? -1 : 1) : 0),
        //     // style: {fontWeight: 'bolder',textAlign: 'center'},
        //     // style: { textAlign: 'center'}, //fontWeight: 'bolder',
        //     columnStyle: {textAlign: 'center'},
        //     setColWidth: function(inWidth){ this.width = inWidth; }
        //   }
        // }
        // if(key==="CENTROMERE_OVERLAP") {
        //   return {
        //     Header: "Cen. Overlaps",
        //     id: key,
        //     accessor: (dt) => dt[key],
        //     width: 50,
        //     sortType: sortFloatColumn,
        //     // style: {fontWeight: 'bolder',textAlign: 'center'},
        //     // style: { textAlign: 'center'}, //fontWeight: 'bolder',
        //     // columnStyle: {textAlign: 'center'},
        //     setColWidth: function(inWidth){ this.width = inWidth; }
        //   }
        // }
        // if(key==="RECURRENT_OVERLAP_SIZE") {
        //   return {
        //     Header: "Recur. Overlap Size",
        //     id: key,
        //     accessor: (dt) => dt[key],
        //     width: 60,
        //     Cell: VanexSegmentSizeCell,
        //     sortType: sortIntColumn,
        //     // style: {fontWeight: 'bolder',textAlign: 'center'},
        //     // style: { textAlign: 'center'}, //fontWeight: 'bolder',
        //     columnStyle: {textAlign: 'center'},
        //     setColWidth: function(inWidth){ this.width = inWidth; }
        //   }
        // }
        // if(key==="MAX_RECURRENT_OVERLAP") {
        //   return {
        //     Header: "Max Recur. Overlaps",
        //     id: key,
        //     accessor: (dt) => dt[key],
        //     width: 50,
        //     sortType: sortFloatColumn,
        //     // style: {fontWeight: 'bolder',textAlign: 'center'},
        //     // style: { textAlign: 'center'}, //fontWeight: 'bolder',
        //     // columnStyle: {textAlign: 'center'},
        //     setColWidth: function(inWidth){ this.width = inWidth; }
        //   }
        // }
        if(key.endsWith(".GT")){
          return {
            // Header: (showPMFPrefix ? `${getSampleLabel(key.slice(0,-3))} [${key}]` : key) ,
            // Header: `${getSampleLabel(key.slice(0,-3))}: ${key}`,
            Header: `${getSampleLabel(getSampleIdFromColumnAccessor(key))} [${key}]`,
            id: key,
            accessor: (dt) => dt[key],
            // withCNVOverlapSchematic:true,
            // useGenotypeColor:true,
            // use_AFinsteadOf_Alt_Percent:true,
            Cell: VanexMTGenotypeCell,
            // Cell: VanexGenotypeCell,
            width: 46, //46,
            style: { textAlign:'center', paddingTop:'.7em'}, //fontWeight: 'bolder', 
            columnStyle: {textAlign: 'center'},
            sampleLabel: getSampleLabel(key.slice(0,-3)),
            setColWidth: function(inWidth){ this.width = inWidth; }
          }
        }
        if(key.endsWith(".DP")){
          return {
            // Header: (showPMFPrefix ? `${getSampleLabel(key.slice(0,-3))} [${key}]` : key) ,
            // Header: `${getSampleLabel(key.slice(0,-3))}: ${key}`,
            Header: `${getSampleLabel(getSampleIdFromColumnAccessor(key))} DP [${key}]`,
            id: key,
            accessor: (dt) => dt[key],
            // withCNVOverlapSchematic:true,
            // useGenotypeColor:true,
            // use_GTinsteadOf_Alt_Percent:true,
            // Cell: VanexCNVGenotypeCell,
            // Cell: VanexGenotypeCell,
            width: 85, //46,
            style: { textAlign:'center', paddingTop:'.7em'}, //fontWeight: 'bolder', 
            columnStyle: {textAlign: 'center'},
            sampleLabel: getSampleLabel(key.slice(0,-3)),
            setColWidth: function(inWidth){ this.width = inWidth; }
          }
        }
        if(key.endsWith(".AF")){
          return {
            // Header: (showPMFPrefix ? `${getSampleLabel(key.slice(0,-3))} [${key}]` : key) ,
            // Header: `${getSampleLabel(key.slice(0,-3))}: ${key}`,
            Header: `${getSampleLabel(getSampleIdFromColumnAccessor(key))} AF [${key}]`,
            id: key,
            accessor: (dt) => dt[key],
            // withCNVOverlapSchematic:true,
            // useGenotypeColor:true,
            // use_GTinsteadOf_Alt_Percent:true,
            // Cell: VanexCNVGenotypeCell,
            // Cell: VanexGenotypeCell,
            width: 85, //46,
            style: { textAlign:'center', paddingTop:'.7em'}, //fontWeight: 'bolder', 
            columnStyle: {textAlign: 'center'},
            sampleLabel: getSampleLabel(key.slice(0,-3)),
            setColWidth: function(inWidth){ this.width = inWidth; }
          }
        }

        // if(key==="QUAL"){
        //   return {
        //     Header: "Qual",
        //     id: key,
        //     accessor: (dt) => dt[key],
        //     width: 70,
        //     useHeated: true,
        //     // addFilter: true,
        //     Cell: (props) => (  Math.round((Number(props.value) + Number.EPSILON) * 100) / 100 ), // Math.trunc(Number(props.value));
        //     heatedThresholdValue: 120, // ! maybe change later?! or this is good?
        //     style: { textAlign: 'center'},
        //     columnStyle: {textAlign: 'center'},
        //     setColWidth: function(inWidth){ this.width = inWidth; }
        //   }
        // }
        // if(key==="GENE"){
        //   return {
        //     Header: "Gene",
        //     id: key,
        //     accessor: (dt) => dt[key],
        //     width: 130,
        //     // addFilter: true,
        //     defaultCanFilter: true,
        //     // canFilter: true,
        //     // Filter: SelectColumnFilter,
        //     // filter: "equals",
        //     Filter: simpleFilter,
        //     filter: (rows, id, filterValue) => {
        //       return rows.filter(row => {
        //         const rowValue = row.values[id]
        //         return rowValue !== undefined
        //           ? String(rowValue)
        //               .toLowerCase()
        //               .startsWith(String('a').toLowerCase())
        //           : true
        //       })
        //     },
        //     setColWidth: function(inWidth){ this.width = inWidth; }
        //   }
        // }
        // if( key.endsWith('_Alt_Percent')){
        //   // let tmpHeader = ( showPMFPrefix ? key : `${getSampleLabel(key.slice(0,-12))} [${key}]`);
        //   // let tmpHeader = `${getSampleLabel(key.slice(0,-12))}: ${key}`;
        //   let tmpHeader = `${getSampleLabel(getSampleIdFromColumnAccessor(key))}: ${key}`;
        //   let threshold = 100;
        //   // tmpHeader = `x_${tmpHeader}`
        //   return {
        //     Header: tmpHeader,
        //     id: key,
        //     accessor: (dt) => dt[key],
        //     width: 50,
        //     Cell: VanexGenotypeCell,
        //     setColWidth: function(inWidth){ this.width = inWidth; },
        //     // useHeated: true,
        //     sampleLabel: getSampleLabel(key.slice(0,-12)),
        //     useReverseHeated: true,
        //     heatedThresholdValue: threshold
        //   }
        // }
        // if(!!getSampleIdFromColumnAccessor(key)){
        //   return {
        //     // Header: key, //key.substring( key.lastIndexOf("_AD_") + 1) + '_' + key.substring(0, key.lastIndexOf("_AD_") ),
        //     // Header: `${getSampleLabel(key.slice(0,-3))}: ${key}`,
        //     Header: `${getSampleLabel(getSampleIdFromColumnAccessor(key))}: ${key}`,
        //     id: key,
        //     accessor: (dt) => dt[key],
        //     width: 40,
        //     setColWidth: function(inWidth){ this.width = inWidth; },
        //     // style: { textAlign: 'center'}, //fontWeight: 'bolder',
        //     columnStyle: {textAlign: 'center'}
        //   }
        // }
        
        let colHeader = key;
        let colWidth = 100;

        // // ! fix this, this is using RD column-definitions, maybe make it project specific?!
        // let colDefinition = getParameterCaseInsensitive(variantFormatDefinition['column-definitions'],key);
        // if (!!colDefinition){
        //   colHeader = colDefinition['header'] || colHeader;
        //   colWidth = colDefinition['column_width'] || colWidth;
        // }

        // TODO: fix the default withd
        if (colWidth < 30) colWidth = 50;

        return {
          Header: colHeader,
          id: key,
          accessor: (dt) => dt[key],
          width: colWidth,
          // columnStyle: {'display': 'flex', 'flexDirection': 'column', 'justifyContent': 'center'} , //instead of this, I added it to the CSS file
          setColWidth: function(inWidth){ this.width = inWidth; }
        }
      }));
    }
    return [];
  });


  const columnData = React.useMemo(() => (initialColumnData),[initialColumnData]);

  const [hiddenColumnsIds, setHiddenColumnsIds] = useState(props.hiddenColumnsIds || []);
  const [columnOrder, setColumnOrder] = useState(Object.values(columnData).map(i => i.id).filter(t => !hiddenColumnsIds.includes(t)));
  const [sampleColumns, setSampleColumns] = useState({});
  const [PMFSampleColNames, setPMFSampleColNames] = useState(props.PMFSampleColNames || []);
    // it is better to keep it empty at first // const [PMFSampleColNames, setPMFSampleColNames] = useState(props.PMFSampleColNames || columnData.filter(t => t.id.endsWith("_GT")).map(i => i.id).sort( (elA,elB) => (GetSampleRank(elB, true) - GetSampleRank(elA, true)) ) );
  const [sampleTypeModal, setSampleTypeModal] = useState(null);
  const refForChangeSampleTypeModal = React.useRef();
  const [refresh, setRefresh] = useState(false);
  // const [analysisStartedAt, setAnalysisStartedAt] = useState((!!props.analysisStartedAt ? new Date(props.analysisStartedAt).toLocaleString([], {hour: '2-digit', minute:'2-digit', hour12: false}) : 
  //   new Date().toLocaleString([], {hour: '2-digit', minute:'2-digit', hour12: false})));
  // const [analysisStartedAt, setAnalysisStartedAt] = useState(props.analysisStartedAt || new Date().toLocaleString([], {year: 'numeric', month: 'numeric', day: 'numeric', hour: '2-digit', minute:'2-digit', hour12: true}));
  

  function getSampleLabel (sampleID) {
    let label = ''
    if (!!sampleID && !!props.currentAnalysisInfo && !!props.currentAnalysisInfo.SAMPLES){
      // console.log(Object.values(props.currentAnalysisInfo.SAMPLES).find(t => t.SAMPLE_ID === sampleID));
      let sampleInfo = Object.values(props.currentAnalysisInfo.SAMPLES).find(t => t.SAMPLE_ID === sampleID);
      if(!!sampleInfo && !!sampleInfo['SAMPLE_TYPE']) label=sampleInfo['SAMPLE_TYPE'];
    }
    return(label);
  }


  function getTypeOfColumnsInPMFList(columnInfo, short=true, addUnderline=false, inData = PMFSampleColNames) {
    let label='';
    if(!showPMFPrefix){
      if (!!props.currentAnalysisInfo && !!props.currentAnalysisInfo.SAMPLES)
        label= columnInfo.sampleLabel;
    } else {
      switch(inData.indexOf(columnInfo.id)){
        case 0:
          label= ((short) ? 'P' : 'Proband');
          break;
        case 1:
          label= ((short) ? 'M' : 'Mother');
          break;
        case 2:
          label= ((short) ? 'F' : 'Father');
          break;
        default:
          label= '';
      }
    }
    return( (addUnderline && label!=='') ? `${label}_` : label);
  }

  function getSampleColumnId(sampleType, sampleColNames) {
    let smpType = Object.keys(sampleColNames).find(el => sampleColNames[el].toLowerCase()===sampleType.toLowerCase());
    if(!!smpType)
      return(smpType);
    else
      return 'None';
      // return null;
  }

  function getSampleIdFromColumnAccessor(clmnAccessor) {
    let testingSamples='';
    if (!!props.currentAnalysisInfo && !!props.currentAnalysisInfo.SAMPLES){
      props.currentAnalysisInfo.SAMPLES.forEach(element => {
        if(clmnAccessor.includes(element.SAMPLE_ID))
          testingSamples = element.SAMPLE_ID;
        // testingSamples.push(clmnAccessor.includes(element.SAMPLE_ID)); //SAMPLE_TYPE
      });
    }
    // return(testingSamples.some(i => !!i));
    return(testingSamples);
  }

  function getSampleColumnsProbandAtFirst() {
    let columnNamesWOproband = Object.keys(sampleColumns).filter(el => el!==PMFSampleColNames[0]).map(i => i);
    if(!! PMFSampleColNames[0] && PMFSampleColNames[0]!=='None')
      return([PMFSampleColNames[0], ...columnNamesWOproband]);
    else
      return(columnNamesWOproband);
  }

  // const [selectedVariantTab, setSelectedVariantTab] = useState("TAB_ALL_CNV_CALLS_PROBAND");
  const [selectedVariantTab, setSelectedVariantTab] = useState(props.selectedVariantTab || 'TAB_SUMMARY' );


  const [tabs, setTabs] = useState( () => {
    let mainTabLabel="All CNVs";
    let otherSampleIds;
    if(!!props.currentAnalysisInfo && !!props.currentAnalysisInfo.SAMPLES){
      let prbSample = props.currentAnalysisInfo.SAMPLES.find(smp => smp.SAMPLE_TYPE.toLowerCase()==="proband");
      if(!!prbSample && !!prbSample['SAMPLE_ID']) mainTabLabel= `${prbSample.SAMPLE_TYPE} (${prbSample.SAMPLE_ID})`;
      otherSampleIds = props.currentAnalysisInfo.SAMPLES.filter(smp => smp.SAMPLE_TYPE.toLowerCase()!=="proband");//.map(smp => smp.SAMPLE_ID)
    }

    // // * set Analysis_Type specific settings
    // let tabsToShow = -1; // * show all tabs
    // if(!!props.onlyShowOneTab){
    //   tabsToShow = 1;
    // } else if(!!props.currentAnalysisInfo && (props.currentAnalysisInfo.ANALYSIS_TYPE==='GermlineSNV' || props.currentAnalysisInfo.ANALYSIS_TYPE==='SomaticSNV' || props.currentAnalysisInfo.ANALYSIS_TYPE==='GenomeWideDeNovo')){
    //   tabsToShow = 2;
    // }

    // * set tabs
    // if(tabsToShow === 1){
    //   return(
    //     {
    //       'TAB_ALL': {
    //         label: props.oneTabTitle || 'Results',
    //         filters: {}
    //       }
    //     }
    //   );
    // }
    // if(tabsToShow === 2){
    let tabsInfo= {
      'TAB_SUMMARY':
      {
        label: 'Summary',
        filters: {}
      },
      'TAB_ALL_VARIANTS': {
        label: "MT variants", //"Proband's CNVs",
        // label: mainTabLabel,
        filters: {}
      }
    }
    // TODO: uncomment to add tabs for each individual
    // if(!!otherSampleIds && otherSampleIds.length > 0){
    //   otherSampleIds.forEach(smpId => {
    //     tabsInfo = {...tabsInfo, 
    //                   [`TAB_${smpId.SAMPLE_ID}`]: {
    //                     label: `${smpId.SAMPLE_TYPE}`, //`${smpId.SAMPLE_TYPE}'s CNVs`, //"Mother's CNVs",
    //                     // label: `${smpId.SAMPLE_TYPE} (${smpId.SAMPLE_ID})`,
    //                     filters: {}
    //                   }
    //                 }
    //   });
    // }
    return(tabsInfo); 
  });

  const [numberOfReviewSaved, setNumberOfReviewSaved] = useState(null);
  const [numberOfNotesSaved, setNumberOfNotesSaved] = useState(null);
  const canSaveNotes = props.canSaveNotes || (!(!!props.onlyShowOneTab || !props.currentCaseInformation));
  const [isSavingNotes, setIsSavingNotes] = useState(false);
  const [isAutoSavingNotes, setIsAutoSavingNotes] = useState(process.env.NODE_ENV!=='development' || false);
  const [autoSaveNotesInterval, setAutoSaveNotesInterval] = useState(3);
  const [autoSaveNotesCounter, setAutoSaveNotesCounter] = useState(0);
  const [savingNotesProgressbarValue, setSavingNotesProgressbarValue] = useState(0);
  const [isExporting, setIsExporting] = useState(false);
  const [exportProgressbarValue, setExportProgressbarValue] = useState(0);
  const [trigerExportPreparation, setTrigerExportPreparation] = useState(false);
  const [preparedDataFromVariantTable, setPreparedDataFromVariantTable] = useState(null);
  const [VaNexAutoNotes, setVaNexAutoNotes] = useState([]);
  const [showVaNexAutoNotes, setShowVaNexAutoNotes] = useState(false);
  const [showOtherUsersNotes, setShowOtherUsersNotes] = useState(true);
  
  const [latestTablePageIndex, setLatestTablePageIndex] = useState(0);
  // const [notesForCurrentVariant, setNotesForCurrentVariant] = useState([]);
  const [currentVariantId, setCurrentVariantId] = useState(null);

  const [loadingClinVarPlot, setLoadingClinVarPlot] = useState(false);
  const [autoLoadFirefly, setAutoLoadFirefly] = useState(false);
  const [clinVarPlotSrc, setClinVarPlotSrc] = useState('');
  const [errorMessage, setErrorMessage] = useState('');

  const loadClinVarPlot = (currentVariant) => {
    setLoadingClinVarPlot(true);

    let geneName = currentVariant.GENE;
    GetSignedURL('nch-igm-vanex-client',`ClinVarPlots/GRCH38-Varhouse/${geneName.toUpperCase()}%2F${geneName.toUpperCase()}.ALL.png`) 
    .then(result_json => {
      setClinVarPlotSrc(result_json);
      setErrorMessage('');
      setLoadingClinVarPlot(false);
    }).catch(e => {
      setClinVarPlotSrc('');
      setLoadingClinVarPlot(false);
      setErrorMessage(`Failed to load the image. (${e})`);
    });
  }


  useEffect(() => {
    setLoadingClinVarPlot(false);
    setClinVarPlotSrc('');
    setErrorMessage('');
    // setdbSNPSrc('');
    
    let autoNotes = [];

    if(currentVariantId!==null && currentVariantId!==undefined && !!props.caseData && !!props.caseData[currentVariantId]){
      // console.log(currentVariant.VANEX_NOTES);
      // //!!!! autoNotes=`${gnomADCounts},\n${ntDamaging}`
      // setSlectedSegment(props.caseData[currentVariantId]);
      // const chrom=props.caseData[currentVariantId].CHROMOSOME;
      // console.log(chrom);

      let probandSampleId = "";
      if(!!props.currentAnalysisInfo && !!props.currentAnalysisInfo.SAMPLES){
        probandSampleId = props.currentAnalysisInfo.SAMPLES.find(smp => smp.SAMPLE_TYPE.toLowerCase()==="proband");
        if(!!probandSampleId && !!probandSampleId['SAMPLE_ID']) probandSampleId = probandSampleId.SAMPLE_ID;
      }
      // else if(!!chrom && chrom in plotSegmentsData && plotSegmentsData[chrom]===undefined){ } //* this means the last try returned no record, so no need to retry!
    }

    // // autoNotes=`${gnomADCounts},\n${ntDamaging}`
    // autoNotes=[gnomADCounts, ntDamaging]
    // // autoNotes['GNOMAD']=gnomADCounts;
    // // autoNotes['DAMAGING']=ntDamaging;
    // // console.log(currentVariantId);

    if(isAutoSavingNotes && (autoSaveNotesCounter >= autoSaveNotesInterval) ) saveNotes();
    // if(columnId==='VANEX_NOTES' && isAutoSavingNotes){
    // if(isAutoSavingNotes){
    //   if(autoSaveNotesCounter >= autoSaveNotesInterval){
    //     saveNotes();
    //   } else {
    //     setAutoSaveNotesCounter(autoSaveNotesCounter + 1);
    //   // console.log(columnId);
    //   }
    // }

    setVaNexAutoNotes(autoNotes);
  }, [currentVariantId]);


  useEffect(() => {
    let timer;
    if(numberOfNotesSaved!==null && numberOfNotesSaved!==undefined){
      timer = setTimeout(() => {setNumberOfReviewSaved(null); setNumberOfNotesSaved(null)}, 5000);
    }
    return () => {
      clearTimeout(timer);
    };
  }, [numberOfNotesSaved]);
 

  useEffect(() => {
    if(!!preparedDataFromVariantTable){
      navigator.clipboard.writeText(preparedDataFromVariantTable);
      console.log("Copied to Clipboard!");
      // console.log(preparedDataFromVariantTable);
      setPreparedDataFromVariantTable(null);
    }
  }, [preparedDataFromVariantTable]);


  //? --------------------------------------------- Filters ----------------------------------

  // const [filterSelectionIndeterminateCheckboxStatus, setFilterSelectionIndeterminateCheckboxStatus] = useState(UNCHECKED);
  const [filterSelectionFormik, setFilterSelectionFormik] = useState(null);
  const [filterSelectionTitle, setFilterSelectionTitle] = useState('Filtering');
  const [filterSelectionModal, setFilterSelectionModal] = useState(null);
  const refForFilterSelectionModal = React.useRef();
  const refForCreatableSelect = React.useRef();

  const [visibleFilterSets, setVisibleFilterSets] = useState(() => {
    let tmpVisibleSetsObj = [];
    Object.values(filterDefinition.MT_FILTER_SET).filter(t => t.visible === true).forEach( (myFilter, filterInd) => {
    // Object.keys(Object.values(filterDefinition.MT_FILTER_SET).filter(t => t.visible==true)).FILTER_DEFINITIONS).forEach( tabFilterId => {
    // Object.keys(filterDefinition.MT_FILTER_SET[0].FILTER_DEFINITIONS).forEach( filterId => {
      let tmpFilterSet = {};
      let tmpDefinitionObj = {};

      Object.keys(myFilter.FILTER_DEFINITIONS).filter( t => ( myFilter.FILTER_DEFINITIONS[t].visible === true)
      ).forEach( filterId => {
        // * createFilterObjectFromJSON
        // console.log(filterId);
        let filter = myFilter.FILTER_DEFINITIONS[filterId];
        let tmpObj = {
          columnId: filter.column_id,
          label: filter.label,
          value: ( (!!filter.value) ? filter.value : null ),
          visible: (filter.visible===true || filter.visible===false) ? filter.visible : true, 
          editable: (filter.editable===true || filter.editable===false) ? filter.editable : true,
          getFilterDescr: ( (!!filter.value) ? function(){ return(this.label + this.value);} : function(){ return(this.label);} ),
          filterFunction: ConstructFilterFunctions(filter),
          isApplied: (filter.isApplied===true || filter.isApplied===false) ? filter.isApplied : false,
          isSpecial: filter.isSpecial===true
        }
        tmpDefinitionObj[filterId]=tmpObj;
      });
      tmpFilterSet['value']=filterInd;
      tmpFilterSet['label']=myFilter.label;
      tmpFilterSet['user_defined']=false;
      tmpFilterSet['visible']=myFilter.visible;
      tmpFilterSet['FILTER_DEFINITIONS']=tmpDefinitionObj;
      tmpVisibleSetsObj.push(tmpFilterSet);
    });

    //TODO: fetch user filters and add to this with tmpFilterSet['user_defined']=true; (async? in another method?)

    // console.log('tmpVisibleSetsObj');
    // console.log(tmpVisibleSetsObj);
    return(tmpVisibleSetsObj);
  });

  const [isLoadingVisibleFilterSets, setIsLoadingVisibleFilterSets] = useState(false);
  // const [selectedFilterSetIndex, setSelectedFilterSetIndex] = useState(props.defaultFilterSet || null);
  const defaultFilterSet = 0;
  const [selectedFilterSetIndex, setSelectedFilterSetIndex] = useState(null);
  const [isFilterSetModified, setIsFilterSetModified] = useState(false);
  const [filterDescriptions, setFilterDescriptions] = useState([]);
  const [globalTabFilters, setGlobalTabFilters] = useState({});




  //? --------------------------------------------- Apply Filters ----------------------------------

  const groupBy = (data, key) => {
    return data.reduce(function(rval, item) {
      (rval[item[key]] = rval[item[key]] || []).push(item);
      return rval;
    }, {});
  };

  // function notIn(inFunction){ return function(){return !inFunction.apply(this, arguments);};}

  // ! ------ Filter ------
  const applyFilter = (tmpVariantData, tabId) => {
    // if (!!tabs && !!tabs[tabId] && !tabs[tabId].filters) 
    // return([tmpVariantData, []]);
    // console.log("applyFilter");
    let filterSpec = [];
    const IGNORE_FILTERS_4_PLP_CALLS=tabs[tabId].filters.IGNORE_FILTERS_4_PLP_CALLS && tabs[tabId].filters.IGNORE_FILTERS_4_PLP_CALLS.isApplied;

    // ! add this:  check if clinvar then add all variants in those genes to make sure there is no comp.het. !
    Object.values(globalTabFilters).filter(k => !!k['isApplied']).forEach((filterTerm)=> {
      // if (filterTerm.isApplied!== undefined && filterTerm.isApplied!== null && filterTerm.isApplied===true){
        tmpVariantData = Object.values(tmpVariantData).filter( filterTerm.filterFunction(IGNORE_FILTERS_4_PLP_CALLS)); 
      // }
    });


    if(tabId==='TAB_SUMMARY' && !!tabs[tabId] && !!tabs[tabId].filters['MAIN_B'] && !!tabs[tabId].filters['MAIN_B'].isApplied){
      // console.log(tabs[tabId].filters.MAIN_A.filterFunction);
      // tmpVariantData = Object.values(tmpVariantData).filter( tabs[tabId].filters['MAIN_B'].filterFunction()); 
      Object.keys(tabs[tabId].filters).filter(k => !!tabs[tabId].filters[k]['isApplied']).forEach( filterKey => {
        let filterTerm = tabs[tabId].filters[filterKey];
        if( filterKey !=='MAIN_A'){
          tmpVariantData = Object.values(tmpVariantData).filter( filterTerm.filterFunction(IGNORE_FILTERS_4_PLP_CALLS)); 
        }
      });
    } else {
      Object.values(tabs[tabId].filters).filter(k => !!k['isApplied']).forEach((filterTerm)=> {
        tmpVariantData = Object.values(tmpVariantData).filter( filterTerm.filterFunction(IGNORE_FILTERS_4_PLP_CALLS, PMFSampleColNames));
      });
      // * making sure that TAB_Filter is applied after other filters
      if( !!tabs[tabId] && !!tabs[tabId].filters['MAIN'] ){
        tmpVariantData = Object.values(tmpVariantData).filter( tabs[tabId].filters['MAIN'].filterFunction());
      }
    }

    return([tmpVariantData, filterSpec]);
  }


  const updateFilterSet = (filterSetIndex, selectedTabId) => {
    let tmpTabFilterObj = {};

    // * add Tab-Filters defined in the JSON for this tab
    let tabFilterDefinition = filterDefinition.RD_TAB_FILTER_SET.FILTER_DEFINITIONS[selectedTabId];
    if(tabFilterDefinition !== undefined && tabFilterDefinition !==null){
      Object.keys(tabFilterDefinition).forEach( tabFilterId => {
        // * createFilterObjectFromJSON
        let filter = tabFilterDefinition[tabFilterId];
        let tmpObj = {
          columnId: filter.column_id,
          label: filter.label,
          value: null,
          visible: (filter.visible===true || filter.visible===false) ? filter.visible : false, 
          editable: (filter.editable===true || filter.editable===false) ? filter.editable : false,
          getFilterDescr: function(){ return(this.label)},
          filterFunction: ConstructFilterFunctions(filter),
          isApplied: (filter.isApplied===true || filter.isApplied===false) ? filter.isApplied : true,
          isSpecial: filter.isSpecial===true
        }
        tmpTabFilterObj[tabFilterId]=tmpObj;
      });
    }

    // * add filters from visibleFilterSets
    if (filterSetIndex !==undefined && filterSetIndex !== null && !!visibleFilterSets &&
      !!visibleFilterSets[filterSetIndex] && !!visibleFilterSets[filterSetIndex].FILTER_DEFINITIONS){
      Object.keys(visibleFilterSets[filterSetIndex].FILTER_DEFINITIONS).forEach( filterId => {
        tmpTabFilterObj[filterId]={...visibleFilterSets[filterSetIndex].FILTER_DEFINITIONS[filterId]};
      });
    }

    setTabs( prevTabs => ({
      ...prevTabs,
      [selectedTabId]: {
        ...prevTabs[selectedTabId],
        filters: tmpTabFilterObj
      }
    }));

  }

 
  //? --------------------------------------------- main useEffects ---------------------------------- 
  const [mainUseEffectsIsDone, setMainUseEffectsIsDone] = useState(false);

  // * by default it uses the first filter set defined in filters.json file. 
  useEffect(() => {
    // set Modal for selecting column filters
    setFilterSelectionModal( new Modal(refForFilterSelectionModal.current));

    // set Modal for changing sample type
    setSampleTypeModal( new Modal(refForChangeSampleTypeModal.current));

    // ! fix   'MR_PHENE_PHENOTYPE_TERMS' in all three 
    // const defaultColumnOrder = ['VANEX_TAGS','CHROMOSOME','LOC_START','LOC_END','SEG_SIZE','CNV_TYPE','SEG_MEAN','P_GT','VANEX_NOTES','NUM_MARK','ENTREZ_IDS','GENE_SYMBOLS','OMIM_PHENOTYPES','MR_PHENE_PHENOTYPE_TERMS','MAX_RECURRENT_OVERLAP','RECURRENT_OVERLAP_SIZE','CENTROMERE_OVERLAP']; // , 'VANEX_REVIEWS', 'CLINVAR_CLNSIG' ,'MR_PHENE_PHENOTYPE_TERMS'
    let defaultVisibleColumns = ['VANEX_TAGS','VANEX_NOTES','VANEX_REVIEWS','CHROMOSOME','POSITION','REF','ALT','FILTER','GENE','AaChange','Pathogenicity','dbSNP','MitomapAssociatedDiseases','MitomapSomaticMutations', 'NtVarH', 'NtVarP',  'MutPred_Prediction', 'Panther_Prediction',  'Polyphen2HumDiv_Prediction',  'Polyphen2HumVar_Prediction']; // , 'VANEX_REVIEWS', 'CLINVAR_CLNSIG' ,'MR_PHENE_PHENOTYPE_TERMS'
    let include_GT = true;
    let include_Alt_Percent = false;
    let columnToUseForPMF = '.GT';

    if(!!props.onlyShowOneTab) defaultVisibleColumns.push('CASE_ID')


    let hiddenCols = [];
    if(!props.hiddenColumnsIds){
      // * set hidden columns
      // hiddenCols = Object.keys(inputData[0]).filter(t => !defaultVisibleColumns.includes(t) ).map( k => k);
      //! fix this, move columnData to here?! and then use the top line instead of the below

      Object.values(columnData).forEach(column => {
        if(!defaultVisibleColumns.includes(column.id) &&
            !(include_GT && column.id.endsWith('.GT')) &&
            // !(include_GT && column.id.endsWith('.AF')) &&
            // !(include_GT && column.id.endsWith('.DP')) &&
            !(include_Alt_Percent && column.id.endsWith('_Alt_Percent'))
          ){
          hiddenCols.push(column.id);
        }
      });
      setHiddenColumnsIds(hiddenCols);
      // setHiddenColumnsIds(["CHROM","POS","ROW_INDEX","ENTREZ_ID"])
    } else { hiddenCols = hiddenColumnsIds}


    Object.keys(tabs).forEach( tabId => {
      let filterSetIndex = undefined;
      if(tabId!=='TAB_SUMMARY') filterSetIndex = defaultFilterSet ;
      updateFilterSet(filterSetIndex, tabId);
    } );

    // setSelectedFilterSetIndex(defaultFilterSet);

    if(selectedVariantTab === 'TAB_SUMMARY') 
      setSelectedFilterSetIndex(null);

    let sampleColNames = {};
    if (!!props.currentAnalysisInfo && !!props.currentAnalysisInfo.SAMPLES){
      props.currentAnalysisInfo.SAMPLES.sort( (elA,elB) => (GetSampleRank(elB.SAMPLE_TYPE) - GetSampleRank(elA.SAMPLE_TYPE)) ).forEach(element => {
        sampleColNames[`${element.SAMPLE_ID}${columnToUseForPMF}`]=element.SAMPLE_TYPE;
        // sampleColNames[element.SAMPLE_TYPE]=`${element.SAMPLE_ID}${columnToUseForPMF}`;
      });
      if (!props.PMFSampleColNames)
        setPMFSampleColNames( [getSampleColumnId('Proband', sampleColNames), getSampleColumnId('Mother', sampleColNames), getSampleColumnId('Father', sampleColNames) ]);
      
    } else {
      columnData.filter(t => t.id.endsWith(columnToUseForPMF))
        .map(i => i.id)
        .sort( (elA,elB) => (GetSampleRank(elB, true) - GetSampleRank(elA, true)) )
        .forEach(element => {
          sampleColNames[element]="None";
        });
    }
    // * example of sampleColNames: 
    // {
    //   "RD0393_p_GT": "Proband",
    //   "RD0393_m_GT": "Mother",
    //   "RD0393_f_GT": "Father"
    // }
    setSampleColumns(sampleColNames);

    // * set column order
    // if (!!props.PMFSampleColNames) sampleColNames= PMFSampleColNames;
    // if(sampleColNames.length > 0){
    //   let colOrder = Object.values(columnData).map(i => i.id).filter(t => (!hiddenCols.includes(t) && !PMFSampleColNames.includes(t) ) );
    //   console.log(colOrder);
    //   console.log(PMFSampleColNames);
    //   colOrder =[...colOrder, ...PMFSampleColNames]
    //   console.log(colOrder);
    //   setColumnOrder( colOrder );
    // }
    // console.log("columnData", columnData);
    setColumnOrder( Object.values(columnData).map(i => i.id).filter(t => !hiddenCols.includes(t)) );
            //.sort( (elA,elB) => (defaultColumnOrder.indexOf(elA) - defaultColumnOrder.indexOf(elB)) )
    // setColumnOrder( Object.values(columnData).map(i => i.id).filter(t => !hiddenCols.includes(t)).sort( (elA,elB) => (defaultVisibleColumns.indexOf(elA) - defaultVisibleColumns.indexOf(elB))  ) );



    // ! does this work? fix it if not!
    if(!props.userName && canSaveNotes){ 
      toast.error(`Cannot save notes since you are either not logged in or your session has expired! (${props.userName})`, {duration:8000});
    }
    setMainUseEffectsIsDone(true);

  }, []);


  function downloadIndividualFile(signedURL) {  // , userName
    return new Promise(function (resolve, reject) {
      fetch(signedURL, {
        method: 'GET',
        mode: 'cors'
      })
      .then(response => {     
        if (!response.ok) { // if (status >= 200 && status < 300) {
          reject("HTTP error " + response.status);
        }
        const responseText = response.text();
        resolve(responseText);
      })
      .catch(e => {
        reject("Failed to fetch the data.", e); //! fix the error message!
      });
    });
  }




  const variantData = React.useMemo(() => {
    let [filteredVariantData, filterSpec] = applyFilter(props.caseData, selectedVariantTab);  // ! [...props.caseData] or  props.caseData ?
    setFilterDescriptions(filterSpec);
    return(filteredVariantData);
    // return(props.caseData);
  }, [tabs, globalTabFilters, selectedVariantTab, props.caseData, refresh]); //! deconstruct props and use individual ones??     // selectedPathwayGeneEntrezIds


  useEffect(() => {
    setLatestTablePageIndex(0);
  }, [tabs, globalTabFilters, selectedVariantTab]);



  //? --------------------------------------------- saveNotes ----------------------------------

  const saveNotes = () => {
    // toast.error(`Cannot save notes yet! 🙁 (${props.userName} - ${props.currentCaseInformation.CASE_ID})`);
    // return 1;

    // ! find a better way to update progress bar?
    const updateSavingNotesProgress = (value, final=false) => {
      
      setSavingNotesProgressbarValue(value);
      // const interval = setInterval(() => {  // ! fix this!
      //   setSavingNotesProgressbarValue(value);
      //   if(final || value > 90) {
      //     setIsSavingNotes(false);
      //     clearInterval(interval);
      //   }
      // }, 400);
    }

    // ! does this work? fix it if not!
    if(!(!!props.userName && !!props.currentCaseInformation.CASE_ID)){
      toast.error(`Cannot save notes since you are either not logged in or your session has expired 🙁 (${props.userName} - ${props.currentCaseInformation.CASE_ID})`);
      return 1;
    }

    setIsSavingNotes(true);

    updateSavingNotesProgress(10);

    // const recordsWithReview = Object.values(props.caseData).filter(t => ( t.VANEX_REVIEWS['REVIEW_VALUE']>0) )
    // .map( variant => (({ VANEX_REVIEWS, CHROMOSOME, POSITION, REF, ALT }) => {
    //   let tmpDate = (!!VANEX_REVIEWS['UPDATED_AT'] ? VANEX_REVIEWS['UPDATED_AT'] : new Date() );
    //   return({ REVIEW_VALUE:VANEX_REVIEWS['REVIEW_VALUE'] || -1, CHROMOSOME, POSITION, REF, ALT, UPDATED_AT:tmpDate })
    // })(variant));
    
    // if(!!recordsWithReview && recordsWithReview.length > 0) {
    //   // console.log(recordsWithReview);
    //   let caseId = props.currentCaseInformation.CASE_ID; // *no need for .toUpperCase();
    //   let userName= "REVIEWS";
    //   let fileName= `${caseId}_${props.currentAnalysisInfo.ANALYSIS_ID}_${userName}.json.gz`;
      
    //   // const resultAsBinString = pako.gzip(Object.values(recordsWithReview).map(x=>JSON.stringify(x)).join(''));
    //   const resultAsBinString = pako.gzip(JSON.stringify(recordsWithReview));
      
    //   // const stringUtf16ThatWeNeedInUtf8 = JSON.stringify(recordsWithReview);
    //   // const stringUtf8 = unescape(encodeURIComponent(stringUtf16ThatWeNeedInUtf8));
    //   // const resultAsBinString = pako.gzip(stringUtf8);
    //   // const gzippedBlob = new Blob([resultAsBinString]);

    //   GetSignedURL('nch-igm-vanex',`mt_case_notes/CASE_ID=${caseId}/ANALYSIS_ID=${props.currentAnalysisInfo.ANALYSIS_ID}/USERNAME=${userName}/${fileName}&upload=true`)
    //   .then(result_json => { 
    //     updateSavingNotesProgress(25);
    //     return(
    //       fetch(result_json, {
    //         method: 'PUT',
    //         // headers: {
    //         //   'Content-Type': 'application/json'
    //         //   'Content-Encoding': 'gzip',
    //         // },
    //         body: resultAsBinString //Object.values(recordsWithReview).map(x=>JSON.stringify(x)).join('\n')
    //       })
    //     );
    //   }).then( response => {
    //     if(response.status === 200){
    //       setNumberOfReviewSaved(Object.keys(recordsWithReview).length);
    //       // toast.success(`${Object.keys(recordsWithReview).length} Reviews Saved!`, {duration:2000});
    //       // setShouldBlockNavigation(false);
    //       // setIsSavingNotes(false);
    //       // setAutoSaveNotesCounter(0);
    //     }
    //     else { throw Error(`${response.status} - ${response.statusText}`); }
    //   }).catch(e => {
    //     toast.error(`Failed to save review data. (${e})`);
    //     // setShouldBlockNavigation(false);
    //     // setIsSavingNotes(false);
    //   });
    // }

    const userNotes = Object.values(props.caseData).filter(t => (!!t.VANEX_TAGS || !!t.VANEX_NOTES['CURRENT_USER_NOTE']) )
    .map( variant => (({ VANEX_TAGS, VANEX_NOTES, CHROMOSOME, POSITION, REF, ALT }) => {
      let tmpDate = (!!VANEX_NOTES['UPDATED_AT'] ? VANEX_NOTES['UPDATED_AT'] : new Date() );
      return({ VANEX_TAGS, VANEX_NOTES:VANEX_NOTES['CURRENT_USER_NOTE'] || '', CHROMOSOME, POSITION, REF, ALT, UPDATED_AT:tmpDate })
    })(variant));
    // .map( variant => ( ({ VANEX_TAGS, VANEX_NOTES,CHROMOSOME, LOC_START, LOC_END, SEG_MEAN }) => ({ VANEX_TAGS, VANEX_NOTES:VANEX_NOTES['CURRENT_USER_NOTE'],CHROMOSOME, LOC_START, LOC_END, SEG_MEAN, UPDATED_AT:VANEX_NOTES['UPDATED_AT'] }))(variant));

    // const userNotes = Object.values(props.caseData).filter(t => !!t.FILTER ).map( variant => (({ FILTER,CHROMOSOME, LOC_START, LOC_END, SEG_MEAN }) => ({ FILTER,CHROMOSOME, LOC_START, LOC_END, SEG_MEAN }))(variant));
    // const userNotes = Object.values(props.caseData).filter(t => !!t.FILTER ).map( variant => (({ FILTER,CHROMOSOME, LOC_START, LOC_END, SEG_MEAN }) => ({ FILTER,CHROMOSOME, LOC_START, LOC_END, SEG_MEAN, VARIANTID: `${CHROMOSOME}_${POSITION}_${REF}_${ALT}` }))(variant));
    // const userNotes = Object.values(props.caseData).filter(t => !!t.FILTER ).map( variant => (({CHROMOSOME, LOC_START, LOC_END, SEG_MEAN, FILTER, index }) => ({CHROMOSOME, LOC_START, LOC_END, SEG_MEAN, FILTER, index }))(variant));
    
    // * no need to check for this
    // if(!(!!userNotes && userNotes.length > 0)) {
    //   toast.error('No Notes to Save!');
    //   setShouldBlockNavigation(false);
    //   setIsSavingNotes(false);
    //   return;
    // }

    let caseId = props.currentCaseInformation.CASE_ID; // *no need for .toUpperCase();
    let userName= props.userName.replaceAll(' ','_');                     // ! do we need to make it .toUpperCase()?
    let fileName= `${userName}.json`;
    //!! add this back let fileName= `${caseId}_${props.currentAnalysisInfo.ANALYSIS_ID}_${userName}.json`;
    // const url_to_fetch = ENDPOINT_BASE+`get_signed_url?upload=true&bucket=nch-igm-vanex&key=mt_case_notes/CASE_ID=${caseId}/${userName}.json`;
    // const url_to_fetch = ENDPOINT_BASE+`get_signed_url?upload=true&bucket=nch-igm-vanex&key=mt_case_notes/CASE_ID=${caseId}/USERNAME=${userName}/${userName}.json`;
    GetSignedURL('nch-igm-vanex',`mt_case_notes/CASE_ID=${caseId}/ANALYSIS_ID=${props.currentAnalysisInfo.ANALYSIS_ID}/USERNAME=${userName}/${fileName}&upload=true`)
    .then(result_json => {
      updateSavingNotesProgress(50);
      return(
        fetch(result_json, {
          method: 'PUT',
          headers: {
            // 'Accept': 'application/json',
            'Content-Type': 'application/json',
          },
          body: Object.values(userNotes).map(x=>JSON.stringify(x)).join('\n')
          // body: JSON.stringify(userNotes)
          // body: JSON.stringify({a: 1, b: 'Textual content'})
        })
      );
    }).then( response => {
      if(response.status === 200){
        setNumberOfNotesSaved(Object.keys(userNotes).length);
        // setTimeout(() => {setSaveNotesMessage(`${Object.keys(userNotes).length} Notes Saved!`)}, 1000); //! fix this hack!
        // toast.success(`${Object.keys(userNotes).length} Notes Saved!`, {duration:2000});
        setShouldBlockNavigation(false);
        setIsSavingNotes(false);
        setAutoSaveNotesCounter(0);
      }
      else { throw Error(`${response.status} - ${response.statusText}`); }
    }).catch(e => {
      toast.error(`Failed to save notes. (${e})`);
      setShouldBlockNavigation(false);
      setIsSavingNotes(false);
    });

  }

  //? --------------------------------------------- Exports ----------------------------------

  const shouldExportThisTab = (scope, tabId) => {
    switch(scope){
      case 'summary':
        return(tabId==='TAB_SUMMARY');
      case 'noOriginalData':
        return(tabId!=='TAB_ALL');
      default:
        return true;
    }
  }

  const notesOptions = (scope) => {
    if(scope==='autoSavingNotes')
      setIsAutoSavingNotes(prevState => !prevState);
    if(scope==='hideOtherUsersNotes')
      setShowOtherUsersNotes(prevState => !prevState);
  }

  const exportSnvAsXlsx = (scope) => {

    if (scope==="clipboard"){
      setTrigerExportPreparation(true);
      // navigator.clipboard.writeText(preparedDataFromVariantTable);
      // navigator.clipboard.writeText(createTable());
      return;
    }

    // ! find a better way to update progress bar?
    const updateExportProgress = (value, final=false) => {
      setExportProgressbarValue(value);
      // setTimeout(() => {setExportProgressbarValue(value)}, 100); //! fix this hack!
      // const interval = setInterval(() => { // ! fix this!
      //   setExportProgressbarValue(value);
      //   if(final || value > 90) {
      //     setIsExporting(false);
      //     clearInterval(interval);
      //   }
      // }, 400);
    }

    setIsExporting(true);
    
    let outputFileName = "VaNex-output";
    let xlsxSheetData= [];

    updateExportProgress(1);
    // let deepCopiedCaseData = JSON.parse(JSON.stringify(props.caseData));
    const deepCopiedCaseData = structuredClone(props.caseData);
    updateExportProgress(10);

    let totalTabs = Object.keys(tabs).length;
    Object.keys(tabs).forEach( (tabId, index) => {
      if(shouldExportThisTab(scope, tabId)){
        // * apply filteres for each tab!
        let [tmpVariantData, filterSpec]= applyFilter(deepCopiedCaseData, tabId); //! [...props.caseData], tabId);  // ! [...props.caseData] or  props.caseData ?
        Object.keys(tmpVariantData).forEach( rId => {tmpVariantData[rId].VANEX_NOTES = tmpVariantData[rId].VANEX_NOTES['CURRENT_USER_NOTE']});
        
        // * add a sheet for each tab!
        xlsxSheetData.push([tabs[tabId].label , XLSX.utils.json_to_sheet(tmpVariantData, {header:['VANEX_TAGS', 'VANEX_NOTES', 'CHROMOSOME' ]})]);
        // xlsxSheetData.push([tabs[tabId].label , XLSX.utils.json_to_sheet(tmpVariantData, {header:['CHROMOSOME' POSITION	STOP_POSITION	REF	ALT	SAMPLES	INHERIT_MODEL	QUAL	FILTER	GENE	ENTREZ_ID	LOC_IN_GENE	DIST_TO_SPLICE_SITE	DIST_TO_CODING_REGION	EFFECT	IMPACT	MANE_HGVS	HGVS	HGVS_ALL_PRIORITIZED	INFORMATION, 	ROW_INDEX	VANEX_TAGS	VANEX_NOTES']})]);
      }
      updateExportProgress(10+((index+1)*(60/totalTabs)));
    });

    updateExportProgress(70);

    //! add this? xlsxSheetData.push(['Filtered (raw)' , XLSX.utils.json_to_sheet(props.caseData)]);
    //! add this? xlsxSheetData.push(['Filtered (Global)' , XLSX.utils.json_to_sheet(globalFilteredVariantData)]);
    //! add this? xlsxSheetData.push(['Selected' , XLSX.utils.json_to_sheet(variantData)]);

    const wb = XLSX.utils.book_new();
    xlsxSheetData.forEach( element => {
      // console.log('appending: ', element);
      XLSX.utils.book_append_sheet(wb, element[1], element[0]);  
    });

    updateExportProgress(80);

    if(!!props.currentCaseInformation){
      XLSX.utils.book_append_sheet(wb, XLSX.utils.json_to_sheet([props.currentCaseInformation]), "Case Info");
      if(!!props.currentCaseInformation.CASE_ID){
        outputFileName = props.currentCaseInformation.CASE_ID;
      }
    }
    if(!!props.currentAnalysisInfo){
      XLSX.utils.book_append_sheet(wb, XLSX.utils.json_to_sheet([props.currentAnalysisInfo]), "Analysis Info");
    }

    updateExportProgress(90);
    /* generate XLSX file and send to client */
    XLSX.writeFile(wb, outputFileName + ".xlsx");
    toast.success('Export Completed!');
    setIsExporting(false); // updateExportProgress(99, true);
  }

  //? --------------------------------------------- process values ----------------------------------

  // const showWithPrecision = (inGnomadFreq, decNum=2) => {
  //   let gnomadFreq = inGnomadFreq;
  //   if (inGnomadFreq !== undefined && inGnomadFreq !== null){
  //     gnomadFreq = Number(gnomadFreq);
  //     return(gnomadFreq.toPrecision(decNum));
  //     // if(gnomadFreq!==0) return gnomadFreq.toFixed(decNum);
  //   }
  //   return gnomadFreq
  // }

  const processOMIMArrayTerms = (omimTermsString) => {
    // let omimTerms = omimTermsString.split(';');
    return(
      omimTermsString.map((term, index) => {
        return(
          <div  key={index} className="rounded-pill px-2 mx-2 my-1 border-light-blue d-flex flex-row flex-nowrap text-nowrap align-items-center justify-content-center" 
            dangerouslySetInnerHTML={{ __html: term.replaceAll(/,? ?autosomal dominant/ig, '<span class="ms-1 badge bg-orange">AD</span>')
              .replaceAll(/,? ?autosomal recessive/ig, '<span class="ms-1 badge bg-green">AR</span>')
              .replaceAll(/,? ?X-linked dominant/ig, '<span class="ms-1 badge bg-orange">XLD</span>')
              .replaceAll(/,? ?X-linked recessive/ig, '<span class="ms-1 badge bg-green">XLR</span>') }} />
        );
      })
    );
  }


  // //? --------------------------------------------- IGV ----------------------------------
  // !! IGV stuff, took out 

  //? --------------------------------------------- renders ----------------------------------

  const showWithPrecision = (inGnomadFreq, decNum=2) => {
    let gnomadFreq = inGnomadFreq;
    if (inGnomadFreq !== undefined && inGnomadFreq !== null){
      gnomadFreq = Number(gnomadFreq);
      return(gnomadFreq.toPrecision(decNum));
      // if(gnomadFreq!==0) return gnomadFreq.toFixed(decNum);
    }
    return gnomadFreq
  }

  const getPredictionStyle = (prediction, mutTaster=false) => {
    let predictionStyle = 'rounded-pill px-2 pt-1 ';
    let predictionText = '';
    if(prediction !== null && prediction !==undefined && prediction !=='.' ){
      if(prediction.toLowerCase()==='d'){
        predictionStyle += ' text-danger ';
        predictionText = 'Damaging';
      }
      else if(prediction.toLowerCase()==='p'){
        predictionStyle += ' text-danger ';
        predictionText = 'Pathogenic';
      }
      else if(prediction.toLowerCase()==='m'){
        predictionStyle += ' text-danger ';
        predictionText = 'Medium';
      }
      else if(prediction.toLowerCase()==='h'){
        predictionStyle += ' text-danger ';
        predictionText = 'High';
      }
      else if(prediction.toLowerCase()==='t'){
        predictionStyle += ' text-success ';
        predictionText = 'Tolerated';
      }
      else if(prediction.toLowerCase()==='b'){
        predictionStyle += ' text-success ';
        predictionText = 'Benign';
      }
      else if(prediction.toLowerCase()==='n'){
        predictionStyle += ' text-success ';
        predictionText = 'Neutral';
      }
      else if(prediction.toLowerCase()==='l'){
        predictionStyle += ' text-success ';
        predictionText = 'Low';
      }
      else if(prediction.toLowerCase()==='u'){
        predictionStyle += ' text-warning fw-bold ';
        predictionText = 'Unknown';
      }
      else {
        predictionText = prediction;
      }
      if(mutTaster){
        if(prediction.toLowerCase()==='d'){
          predictionStyle += ' text-danger ';
          predictionText = 'Disease causing';
        }
        else if(prediction.toLowerCase()==='a'){
          predictionStyle += ' text-danger text-small ';
          predictionText = 'Disease causing auto.';
        }
        else if(prediction.toLowerCase()==='n'){
          predictionStyle += ' text-success';
          predictionText = 'Polymorphism';
        }
        else if(prediction.toLowerCase()==='p'){
          predictionStyle += ' text-success text-small ';
          predictionText = 'Polymorphism automatic';
        }
      }
      return(<div className={predictionStyle}>{predictionText}</div>)
    }
    else{
      return(<div>{prediction}</div>)
      // return(<div></div>)
    }
  }


  const renderVariantInfo = () => {
    if(currentVariantId===null || !props.caseData[currentVariantId]){
      return(
        <div className="bottom-var-info-panel d-flex flex-column">
          <div className="d-flex overflow-auto flex-column flex-nowrap">
            <div className="card m-2 shadow-sm flex-grow-1">
              {/* <h5 className="card-header bg-light-blue">Variant</h5> */}
              <div className="card-body d-flex flex-row flex-nowrap align-items-center justify-content-center">
                <h3>No variant selected</h3>
              </div>
            </div>
          </div>
        </div>
      );
    }
    else{
      const variant = props.caseData[currentVariantId];

      // console.log("variant: ", variant);
      // console.log({name: variant.GENE, entrez_id:variant.ENTREZ_ID});
      // console.log([{POSITION:parseInt(variant.POSITION), PRT_POS:getPrtPos(variant.MANE_HGVS)}]);

      return(
        <div className="bottom-var-info-panel d-flex flex-column">
          <div className="d-flex overflow-auto flex-column flex-nowrap mb-5">
            
            <div className="card m-1 shadow-sm flex-grow-1">
              <h5 className="variant-card-header bg-light-blue d-flex flex-row">
                Variant: <div className="mx-2 user-select-all variant-full-name-display">{variant.CHROMOSOME}-{variant.POSITION}-{variant.REF}-{variant.ALT}</div> 
                <span className="ms-5">Gene: <span className="mx-1 user-select-all">{variant.GENE}</span> </span>
                <span className="ms-5">Position: <span className="mx-1 user-select-all">{variant.CHROMOSOME}:{variant.POSITION}</span> </span>
              </h5>
              <div className="variant-card-body d-flex flex-row flex-wrap align-items-center justify-content-center">
                <div className="d-flex flex-row flex-nowrap align-items-center justify-content-center flex-grow-0" style={{minWidth:'30rem'}}>
                  <div className="variant-item text-start">
                    <a href={'https://varsome.com/variant/hg38/'+variant.CHROMOSOME+'-'+variant.POSITION+'-'+variant.REF+'-'+variant.ALT+'?annotation-mode=germline'}  target="_blank" rel="noreferrer"><i className="fas fa-check"></i> Varsome</a>
                    {/* <div className="mt-2">
                      {(variant.DBSNP_ID===null || variant.DBSNP_ID===undefined) ?
                        <span><i className="fas fa-external-link-alt"></i> dbSNP</span> :
                        <a href={'https://www.ncbi.nlm.nih.gov/snp/?term='+variant.DBSNP_ID} target="_blank" rel="noreferrer"><i className="fas fa-external-link-alt"></i> dbSNP</a>
                      }
                    </div> */}
                  </div>
                  <div className="variant-item text-start">
                    {/* <a href={'http://localhost:60151/goto?locus=chr'+variant.CHROMOSOME+':'+variant.POSITION+'-'+variant.POSITION} target="_blank" rel="noreferrer"><i className="fas fa-align-center"></i> IGV</a> */}
                    {(variant.GENE===null || variant.GENE===undefined || variant.GENE===".") ?
                      <span><i className="fas fa-external-link-alt"></i> N/A </span> :
                      <a href={'https://www.genecards.org/cgi-bin/carddisp.pl?gene='+variant.GENE} target="_blank" rel="noreferrer"><i className="fas fa-dna"></i> {variant.GENE}</a>
                    }
                    {/* <div className="mt-2"><a href={'http://denovo-db.gs.washington.edu/denovo-db/QueryVariantServlet?searchBy=Gene&target='+variant.GENE} target="_blank" rel="noreferrer"><i className="fas fa-external-link-alt"></i> denovo-db</a></div> */}
                  </div>
                  <div className="variant-item text-start" style={{minWidth:'fit-content'}}>
                    <a href={'http://genome.ucsc.edu/cgi-bin/hgTracks?db=hg38&position='+variant.CHROMOSOME+':'+variant.POSITION+'-'+variant.POSITION} target="_blank" rel="noreferrer"><i className="fas fa-external-link-alt"></i> UCSC</a>
                    {/* <div className="mt-2"><a href={'https://gene.sfari.org/database/human-gene/'+variant.GENE} target="_blank" rel="noreferrer"><i className="fas fa-external-link-alt"></i> SFARI</a></div> */}
                  </div>
                  <div className="variant-item text-start" style={{minWidth:'fit-content'}}>
                    {(variant.dbSNP===null || variant.dbSNP===undefined || variant.dbSNP===".") ?
                      <span><i className="fas fa-external-link-alt"></i> dbSNP</span> :
                      <a href={'https://www.ncbi.nlm.nih.gov/snp/'+variant.dbSNP} target="_blank" rel="noreferrer"><i className="fas fa-external-link-alt"></i> dbSNP</a>
                    }
                  </div>
                  <div className="variant-item text-start">
                    <a href={'https://gnomad.broadinstitute.org/variant/'+variant.CHROMOSOME+'-'+variant.POSITION+'-'+variant.REF+'-'+variant.ALT+'?annotation-mode=germline'}  target="_blank" rel="noreferrer"><i className="fas fa-external-link-alt"></i> gnomADv4</a>
                  </div>
                  <div className="variant-item text-start" style={{minWidth:'fit-content'}}>
                    AA Change: <span>{variant.AaChange}</span>
                  </div>
                  
                </div>
                {/* <div className="variant-item text-center"><span className="text-muted">Gene</span><br/><a href={'https://www.genecards.org/cgi-bin/carddisp.pl?gene='+variant.GENE} target="_blank" rel="noreferrer"><i className="fas fa-dna"></i> {variant.GENE}</a></div> */}
                {/* <div className="variant-item text-center flex-grow-1 show-overflow">{variant.CHROMOSOME}-{variant.POSITION}-{variant.REF}-{variant.ALT}</div> */}

                {/* <div className="variant-item text-center flex-grow-0"><span className="text-muted">Quality</span><div className="m-1"><span className="px-2 py-1 rounded-pill fw-bold" style={{backgroundColor: GetHeatedQualityScore(variant.QUAL)}}>{variant.QUAL}</span></div></div>
                <div className="variant-item text-center variant-item-HGVS flex-grow-1" style={{minWidth:'min-content'}}>
                  //! fix this: do we need trim? <span className="text-muted">{(variant.MANE_HGVS.trim()!=="") ? 'MANE HGVS' : 'HGVS'}</span>
                  <span className="text-muted">{(variant.MANE_HGVS) ? 'MANE HGVS' : 'HGVS'}</span>
                  <div className="mt-1 limited-text-height d-flex flex-column align-items-center"  style={{width:'100%',height:'4.4rem'}}>
                    {(variant.MANE_HGVS) ? processHGVS(variant.MANE_HGVS) : ( (variant.HGVS) ? processHGVS(variant.HGVS) : '-')}
                    //! here as well {(variant.MANE_HGVS.trim()!=="") ? processHGVS(variant.MANE_HGVS) : ( (variant.HGVS) ? processHGVS(variant.HGVS) : '-')}
                  </div>
                </div>
                <div className="variant-item text-center flex-grow-0 1flex-shrink-1" style={{minWidth:'15rem'}}><span className="text-muted">Loc In Gene</span><div className="">{variant.LOC_IN_GENE}</div></div>
                <div className="variant-item text-center flex-grow-0"><span className="text-muted">Splice Dist</span><div className="">{variant.DIST_TO_SPLICE_SITE}</div></div> */}
              </div>
              {/* <footer className="card-footer text-muted">2 days ago <cite title="Source Title">Source Title</cite></footer> */}
            </div>


            {/* {renderOMIMPhenotypes()} */}
            <VariantInfoBox title="OMIM" min_width="10rem" >
              <div className="variant-item text-start" style={{minWidth:'fit-content'}}>
                  {(variant.OMIM===null || variant.OMIM===undefined || variant.OMIM===".") ?
                    <span className="text-muted "> N/A </span>
                    :
                    <a href={`https://omim.org/entry/${variant.OMIM}`} target="_blank" rel="noreferrer" className=""><i className="fas fa-external-link-alt"></i> {variant.OMIM}</a>
                  }
              </div>

            </VariantInfoBox>


            {/* {renderClinVar()} */}
            <VariantInfoBox title="ClinVar" min_width="10rem" >
            {/* <div className="card m-1 shadow-sm flex-grow-1" style={{minWidth: '10rem'}}> */}
              {/* <h5 className="variant-card-header bg-light-blue">ClinVar</h5> */}
              <div className="variant-card-body d-flex flex-row flex-wrap align-items-center justify-content-center">
                <div className="d-flex flex-row flex-nowrap align-items-center justify-content-center flex-grow-1">
                  <div className="variant-item text-center m-0 p-0 px-1 flex-grow-0" style={{minWidth:'15rem'}}>
                    <div className="mb-1">
                    {(variant.Clinvar===null || variant.Clinvar===undefined || variant.Clinvar===".") ?
                      <span className="text-muted ">ClinVar</span>
                      :
                      <a href={`https://www.ncbi.nlm.nih.gov/clinvar/variation/${variant.Clinvar}/`} target="_blank" rel="noreferrer" className=""><i className="fas fa-external-link-alt"></i> ClinVar Significance</a>
                    }
                    </div>
                    {/* <div>
                      {(variant.CLINVAR_CLNSIG===undefined) ? "Error!" : ( (variant.CLINVAR_CLNSIG===null) ? "-" : 
                      <div className={getClinvarSignificanceStyle(variant.CLINVAR_CLNSIG)}>{String(variant.CLINVAR_CLNSIG ).replaceAll(/_/g," ")  }</div>)}
                    </div> */}
                  </div>
                  {/* <div className="variant-item text-center m-0 p-0 px-1 flex-grow-1 flex-wrap"><span className="text-muted">ClinVar Disease</span><br/>{(variant.CLINVAR_CLNDN===undefined) ? "Error!" : ( (variant.CLINVAR_CLNDN===null) ? "-" : variant.CLINVAR_CLNDN )}</div> */}
                </div>
                {/* <div className="text-center m-1 d-flex flex-row flex-nowrap align-items-center justify-content-center flex-grow-1 ">
                  <div className="variant-item text-center m-1 flex-grow-1"><span className="text-muted">CADD Phred</span><br/>{(variant.DBNSFP_CADD_PHRED===undefined) ? "Error!" : ( (variant.DBNSFP_CADD_PHRED===null) ? "-" : showWithPrecision(variant.DBNSFP_CADD_PHRED, 3) )}</div>
                  <div className="variant-item text-center m-1 flex-grow-1"><span className="text-muted">CADD Raw</span><br/>{(variant.DBNSFP_CADD_RAW===undefined) ? "Error!" : ( (variant.DBNSFP_CADD_RAW===null) ? "-" : showWithPrecision(variant.DBNSFP_CADD_RAW, 3) )}</div>
                </div> */}
              </div>

              <div  className="variant-card-body d-flex flex-column align-items-center justify-content-center">
                {(autoLoadFirefly)
                  ?
                  <>
                    <div className="d-flex flex-row flex-nowrap cursor-pointer" onClick={ () => setAutoLoadFirefly(false)}><i className="far fa-times-circle px-1 fa-lg red-mid"></i>Stop Autoloading Dynamic Plots</div>
                    <Firefly 
                      className="mb-3"
                      // geneNameEntrezId={{name: variant.GENE, entrez_id:variant.ENTREZ_ID}}
                      entrezId={variant.ENTREZ_ID}
                      highlight={ [{POSITION:parseInt(variant.POSITION), PRT_POS:null}]}
                      useStagingEnv = {process.env.REACT_APP_ENV!=='prod'}
                      // highlight={ {PRT_POS:getPrtPos(variant.MANE_HGVS)} }
                      // highlight={variant}
                      // highlight={{POSITION:2, REF:'A', ALT:'C', HGVSc:'HGVSc', HGVSp:'HGVSp'}}
                    />
                  </>
                  :
                    <h5 className="d-flex flex-row flex-nowrap align-items-center justify-content-center cursor-pointer" onClick={ () => setAutoLoadFirefly(true)}>Autoload dynamic plots<i className="far fa-image px-3 fa-2x"></i></h5>
                  }
              </div>
              {/* {renderClinVarPlots()} */}
              {/* <div className="card m-1 shadow-sm flex-grow-1" style={{minWidth: '10rem'}}> */}
                {/* <h5 className="variant-card-header bg-light-blue">ClinVar Plot</h5> */}
                {/* <div className="variant-card-body d-flex flex-row flex-nowrap align-items-center justify-content-center"> */}
                  <div  className="variant-card-body text-center m-0 p-0 d-flex flex-column align-items-center justify-content-center">
                    {/* <br/> */}
                    {/* {(variant.ClinVarPlot) ? */}
                    {(!!clinVarPlotSrc)
                    ?
                      <div id="img-holder">
                        {/* <span id="clinvarMask" tabIndex="1"></span> */}
                        {/* <img id="clinvarPic" tabIndex="2" className="clinvarplot" src={variant.ClinVarPlot} alt="ClinVar Plot"/> */}
                        {/* <img tabIndex="2" className="clinvarplot" src={variant.ClinVarPlot} alt="ClinVar Plot"/> */}
                        {/* <img className="clinvarplot" src={clinVarPlotSrc} alt="ClinVar Plot"/> */}
                        <a href={clinVarPlotSrc} target="_blank" rel="noreferrer"> <img className="clinvarplot mb-2" src={clinVarPlotSrc} alt="ClinVar Plot"/></a>
                      </div>
                    :
                      (loadingClinVarPlot)
                      ?
                      <span><span className="mx-2 spinner-border spinner-border" role="status" aria-hidden="true"> </span><i className="far fa-image px-3 fs-1"></i></span>
                      :
                        (errorMessage.length > 0)
                        ?
                        <h5>{errorMessage}</h5>
                        :
                        <h5 className="d-flex flex-row flex-nowrap align-items-center justify-content-center cursor-pointer" onClick={ () => loadClinVarPlot(variant)}>Load static plot</h5>
                    }
                    </div>
                {/* </div> */}
              {/* </div> */}
            </VariantInfoBox>{/* </div> */}


            {/* {renderDiseaseScore()} */}
            <VariantInfoBox title="Disease Score" min_width="10rem" >
              <div className="variant-item text-start" style={{minWidth:'fit-content'}}>
                  {variant.DiseaseScore}
              </div> 
            </VariantInfoBox>


            {/* {renderPathogenicity()} */}
            <VariantInfoBox title="Pathogenicity" min_width="10rem" >
              <div className="variant-item text-start" style={{minWidth:'fit-content'}}>
                {variant.Pathogenicity}
              </div> 
            </VariantInfoBox>

            {/* {renderPathogenicity()} */}
            {/* <VariantInfoBox title={<span>Pathogenicity <span className="fs-6 ms-3">{`(${VaNexAutoNotes[1].replace(' damaging','')} | ${Number(calCumulativeDamagingScore(variant)).toFixed(2)})`}</span></span>}  */}
            <VariantInfoBox title="in silico tools" min_width="10rem">
              {/* {(damagingScores[3]===0 && damagingScores[7]===0) ? 
                <div className="variant-card-body d-flex flex-row flex-wrap align-items-center justify-content-center">
                  No data available for this variant.
                </div>
              :  */}
              {/* <div className="variant-item text-start" style={{minWidth:'fit-content'}}>
                  {variant.Pathogenicity}
              </div>  */}

              <div className="variant-card-body d-flex flex-row flex-wrap align-items-center justify-content-center">

                <div className="d-flex flex-row flex-wrap align-items-center justify-content-center">
                  {(variant.MutPred_Probability!==undefined && variant.MutPred_Probability!==null) ?
                    <div className="d-flex flex-row flex-nowrap align-items-end pb-0 pt-2 my-1 mx-4 border-bottom border-1 " style={{minWidth:'20rem'}}>
                      <div className="variant-item text-center no-white-space-wrap"><span className="fw-bold">MutPred</span></div>
                      <div className="variant-item text-center">{getPredictionStyle(variant.MutPred_Prediction)}</div>
                      <div className="variant-item text-center">{showWithPrecision(variant.MutPred_Probability, 3)}</div>
                    </div>
                  : '' }

                  {(variant.Panther_Probability!==undefined && variant.Panther_Probability!==null) ?
                    <div className="d-flex flex-row flex-nowrap align-items-end pb-0 pt-2 my-1 mx-4 border-bottom border-1" style={{minWidth:'20rem'}}>
                      <div className="variant-item text-center no-white-space-wrap"><span className="fw-bold">Panther</span></div>
                      <div className="variant-item text-center">{getPredictionStyle(variant.Panther_Prediction)}</div>
                      <div className="variant-item text-center">{showWithPrecision(variant.Panther_Probability, 3)}</div>
                      {/* <div className="variant-item text-center">{showWithPrecision(variant.DBNSFP_METASVM_RANKSCORE, 3)}</div> */}
                    </div>
                  : '' }
                  
                  {(variant.PhDSNP_Probability!==undefined && variant.PhDSNP_Probability!==null) ?
                    <div className="d-flex flex-row flex-nowrap align-items-end pb-0 pt-2 my-1 mx-4 border-bottom border-1" style={{minWidth:'20rem'}}>
                      <div className="variant-item text-center no-white-space-wrap"><span className="fw-bold">PhDSNP</span></div>
                      <div className="variant-item text-center">{getPredictionStyle( variant.PhDSNP_Prediction )}</div>
                      <div className="variant-item text-center">{showWithPrecision(variant.PhDSNP_Probability, 3)}</div>
                    </div>
                  : '' }
                  
                  {(variant.SNPsGO_Probability!==undefined && variant.SNPsGO_Probability!==null) ?
                    <div className="d-flex flex-row flex-nowrap align-items-end pb-0 pt-2 my-1 mx-4 border-bottom border-1" style={{minWidth:'20rem'}}>
                      <div className="variant-item text-center no-white-space-wrap"><span className="fw-bold">SNPsGO</span></div>
                      <div className="variant-item text-center">{getPredictionStyle( variant.SNPsGO_Prediction )}</div>
                      <div className="variant-item text-center">{showWithPrecision(variant.SNPsGO_Probability, 3)}</div>
                    </div>
                  : '' }

                  

                  {(variant.Polyphen2HumDiv_Probability!==undefined && variant.Polyphen2HumDiv_Probability!==null) ?
                    <div className="d-flex flex-row flex-nowrap align-items-end pb-0 pt-2 my-1 mx-4 border-bottom border-1" style={{minWidth:'20rem'}}>
                      <div className="variant-item text-center no-white-space-wrap"><span className="fw-bold">Polyphen2HumDiv</span></div>
                      <div className="variant-item text-center">{getPredictionStyle( variant.Polyphen2HumDiv_Prediction )}</div>
                      <div className="variant-item text-center">{showWithPrecision(variant.Polyphen2HumDiv_Probability, 3)}</div>
                    </div>
                  : '' }

                  {(variant.Polyphen2HumVar_Probability!==undefined && variant.Polyphen2HumVar_Probability!==null) ?
                    <div className="d-flex flex-row flex-nowrap align-items-end pb-0 pt-2 my-1 mx-4 border-bottom border-1" style={{minWidth:'20rem'}}>
                      <div className="variant-item text-center no-white-space-wrap"><span className="fw-bold">Polyphen2HumVar</span></div>
                      <div className="variant-item text-center">{getPredictionStyle( variant.Polyphen2HumVar_Prediction )}</div>
                      <div className="variant-item text-center">{showWithPrecision(variant.Polyphen2HumVar_Probability, 3)}</div>
                    </div>
                  : '' }


                </div>
              </div>
              {/* } */}
            </VariantInfoBox>{/* </div> */}



            {/* {renderIGV()} */}
            <div className="card m-1 p-0 shadow-sm flex-grow-1" style={{minWidth: '10rem'}}>
              {/* <h5 className="variant-card-header bg-light-blue">IGV</h5> */}
              {/* <div className="variant-card-body d-flex flex-row flex-nowrap align-items-center justify-content-center"> */}
              <div className="variant-card-body d-flex flex-column m-1 mt-0 p-0">
                <IgvVaNex chromosome={variant.CHROMOSOME} position={variant.POSITION} currentAnalysisInfo={props.currentAnalysisInfo}/>
              </div>
            </div>

            {/* <VariantInfoBox title={<span>Pathways <span className="fs-6 ms-3">({(!!processedPathwayTerms && !!processedPathwayTerms.length) ? processedPathwayTerms.length : '-'})</span></span>}
              min_width="10em" collapsed> 
            </VariantInfoBox> */}
    
            <VariantInfoBox title="Complete Record" min_width="10em" collapsed>
            {/* <div className="card m-1 shadow-sm flex-grow-1" style={{minWidth: '10rem'}}> */}
              {/* <h5 className="variant-card-header bg-light-blue">Complete Record</h5> */}
              <div className="card-body">
                {/* {Object.keys(variant).map( (element) => { return( String(variant[element])) } ) } */}
                { Object.keys(variant).map( (element, i) => <span className="" key={i}> {element}= { String(variant[element]) } <br/></span>) }
              </div>
            </VariantInfoBox>{/* </div> */}
    
          </div>
        </div>
      );
    }
  }


  const onVariantFilterChange = (event, useGlobalTabFilters) => {
    // console.log(event.target.name , ' is ', event.target.value);
    let currentFilterName = event.target.name;

    if(event.target.type === 'checkbox'){
      if(useGlobalTabFilters){
        setGlobalTabFilters(prevGlobalTabFilters => ({
          ...prevGlobalTabFilters,
          [currentFilterName]: {
            ...prevGlobalTabFilters[currentFilterName],
            isApplied: Boolean(event.target.checked)
          }
        }));
      } else {
        // * update isApplied of this filter in the current tab 
        setTabs( prevTabs => ({
          ...prevTabs,
          [selectedVariantTab]: {
            ...prevTabs[selectedVariantTab],
            filters:{
              ...prevTabs[selectedVariantTab].filters,
              [currentFilterName]: {
                ...prevTabs[selectedVariantTab].filters[currentFilterName],
                isApplied: Boolean(event.target.checked)
              }
            }
          }
        }));
      }
    }
  }


  const renderFilterInfo = (filterList, useGlobalTabFilters) => {

    if(Object.keys(filterList).length === 0){
      return(<label className="list-group-item ps-4">Found None.</label>)
    }
    else{
      return(
        <React.Fragment>
          {Object.keys(filterList).filter( t => filterList[t].editable===true).map((filterTerm, index)=> {
            return(
              <label className="list-group-item pe-2" key={index}>
                <div className="form-check form-switch m-0">
                  <input className="form-check-input me-1" type="checkbox" name={filterTerm} 
                    onChange={(e) => onVariantFilterChange(e, useGlobalTabFilters)} 
                    checked={filterList[filterTerm]["isApplied"]}
                    />
                      <div className="d-flex flex-row">
                      <div className="filter-description flex-grow-1" >{filterList[filterTerm].getFilterDescr() }</div>
                      {(useGlobalTabFilters)
                        ? 
                        <button className="btn move-filter-button flex-center" 
                          onClick={ () => {addFilterToSet(filterList[filterTerm].columnId)}}
                          ><span className="plus-icon-next-to-arrow"><i className="fas fa-plus fa-xs"></i></span><i className="fas fa-level-up-alt"></i>
                        </button>
                      : null }
                    </div>
                </div>
              </label>
            );
          })}
        </React.Fragment>
      );
    }
  }

  // const addNewFilter = () => {
  //   toast((t) => (<span>{"Yay!, you found a hidden gem!"}<br/> {"(under construction)"}</span>),{icon: '👏', duration:5000});
  //   // showAlert("To be added!", 0, true, 'Success!')
  //   // console.log(JSON.stringify(globalTabFilters))
  //   // localStorage.setItem('globalTabFilters', JSON.stringify(globalTabFilters));
  //   // Object.assign(globalTabFilters, JSON.parse(localStorage.getItem('game_status')));

  //   // console.log(JSON.stringify(variantFilterObj))
  //   // localStorage.setItem('variantFilterObj', JSON.stringify(variantFilterObj));
  //   // Object.assign(variantFilterObj, JSON.parse(localStorage.getItem('game_status')));
    
  // }

  const createNewFilterSet = (inputValue) => {
    // * check to make sure there is no other filter-set with the same name (including the invisible ones)
    let filteKey = inputValue.toUpperCase().replace(/\W/g, '');
    console.log(filterDefinition.XLS_FILTER_SET.filter(t => t.label.toUpperCase().replace(/\W/g, '') === filteKey).length > 0);
    if(filterDefinition.XLS_FILTER_SET.filter(t => t.label.toUpperCase().replace(/\W/g, '') === filteKey).length > 0){
      toast.error('The filter-set name needs to be unique. A hidden filter-set might exist!', {duration:6000})
      return;
    }

    setIsLoadingVisibleFilterSets(true);
    const newFilterSet = {
      value: visibleFilterSets.length,
      label: inputValue,
      user_defined: true,
      visible: true,
      FILTER_DEFINITIONS: {},
    }
    setVisibleFilterSets([...visibleFilterSets, newFilterSet]);

    // * show the new FilterSet
    refForCreatableSelect.current.state.value = newFilterSet; // console.log(refForCreatableSelect.current.state.value); // console.log(refForCreatableSelect.current.props);

    updateFilterSet(visibleFilterSets.length, selectedVariantTab);
    setSelectedFilterSetIndex(visibleFilterSets.length);

    setIsLoadingVisibleFilterSets(false);
  }

  const addFilterToSet = (filterName) => {
    // if(visibleFilterSets[selectedFilterSetIndex].user_defined===true){
      setIsLoadingVisibleFilterSets(true);
      setTabs( prevTabs => ({
        ...prevTabs,
        [selectedVariantTab]: {
          ...prevTabs[selectedVariantTab],
          filters:{
            ...prevTabs[selectedVariantTab].filters,
            [filterName]: {...globalTabFilters[filterName]}
          }
        }
      }));

      let tmpGlobalTabFilters = {...globalTabFilters}
      delete tmpGlobalTabFilters[filterName]        //! is there a way to delete a property without copying it first? NO!
      setGlobalTabFilters(tmpGlobalTabFilters);

      setIsFilterSetModified(true);
      setIsLoadingVisibleFilterSets(false);
    // } else {
    //   toast.error("Can only add to filter-set created by you!");
    // }
  }

  const saveFilterSet = () => {
    if(!!refForCreatableSelect.current){
      if (!refForCreatableSelect.current.state.value){
        toast.error("Select a filter-set first!");
      } else if( selectedFilterSetIndex!==null && selectedFilterSetIndex!==undefined && visibleFilterSets[selectedFilterSetIndex].user_defined===true){
        //* update the filterSet first
        setIsLoadingVisibleFilterSets(true);
        let currentFilterSet = {};
        Object.keys(tabs[selectedVariantTab].filters).forEach( filterId => {
          currentFilterSet[filterId] = {...tabs[selectedVariantTab].filters[filterId]}; //! do we need a shallow copy here?
        });

        // console.log(currentFilterSet);
        setVisibleFilterSets(
          prevVisibleFilterSets => prevVisibleFilterSets.map( 
            el => (el.value === selectedFilterSetIndex ? { ...el, FILTER_DEFINITIONS: currentFilterSet } : el ) 
          )
        );
        setIsFilterSetModified(false);
        setIsLoadingVisibleFilterSets(false);
        toast.success("Saved!");
      }
      else {
        toast.error("Cannot make changes to VaNex filters!");
      }
    }
  }

  const onFilterSetSelectChange = (selectedFilterSet, actionMeta) =>{
    if (!!selectedFilterSet){
      updateFilterSet(selectedFilterSet.value, selectedVariantTab);
      setSelectedFilterSetIndex(selectedFilterSet.value);
    }
  }

  const onFilterMenuOpen = (e, b) => {
    if(isFilterSetModified && selectedFilterSetIndex!==null && selectedFilterSetIndex!==undefined && visibleFilterSets[selectedFilterSetIndex].user_defined===true){
    // if(isFilterSetModified){
      setIsFilterSetModified(false);
      toast((t) => (
        <div className="d-flex flex-row ">
          <div>Save your modifications before switching to another filter-set, otherwise <b>they will be lost!</b></div>
          <button className="btn btn-secondary" onClick={() => toast.dismiss(t.id)}>
            Dismiss
          </button>
        </div>
      ), {duration:6000});
      // toast("Modifications will be lost if you switch to another filter-set without saving this one first!", {duration:8000});
      // toast("Save the filter-set before switching to another one if you want to keep your modifications!", {duration:8000});
      // toast((t) => (
      //   <div className="d-flex flex-row">
      //     <b>Do you want to save this <br/>filter-set?</b>
      //     <button className="btn btn-sm btn-primary my-0 ms-3 me-2" onClick={() => toast.dismiss(t.id)}>
      //       Yes
      //     </button>
      //     <button className="btn btn-sm btn-secondary my-0 ms-2 me-0" onClick={() => toast.dismiss(t.id)}>
      //       No
      //     </button>
      //   </div>
      // ), {duration:Infinity});
    }
  }


  const renderFilterList = () => {
    // const options = [ // ! it might be good to show them under groups
    //   {
    //     label: "RD-SNV",
    //     options: [
    //       { label: "Broad", value: "value_1" },
    //       { label: "Specific", value: "value_2" },
    //       { label: "Germline", value: "value_1" },
    //       { label: "Somatic", value: "value_2" }
    //     ]
    //   },
    //   {
    //     label: "Epilepsy",
    //     options: [
    //       { label: "Germline", value: "value_5" },
    //       { label: "Somatic", value: "value_6" }
    //     ]
    //   },
    //   { label: "A root option", value: "value_3" },
    //   { label: "Another root option", value: "value_4" }
    // ];
    return(
      <div className="d-flex flex-row justify-content-center">
        <div className="absolute-panel scroll-div">
          <div className="flex-center flex-row mt-1" >
            <CreatableSelect
              isClearable
              className="flex-grow-1 mx-2"
              ref={refForCreatableSelect}
              isDisabled={isLoadingVisibleFilterSets}
              isLoading={isLoadingVisibleFilterSets}
              onChange={onFilterSetSelectChange}
              // onChange={(selectedFilterSet, actionMeta) => ( (!!selectedFilterSet) ? setSelectedFilterSetIndex(selectedFilterSet.value) : null )}
              onMenuOpen={onFilterMenuOpen}
              onCreateOption={createNewFilterSet}
              options={visibleFilterSets}
              // defaultValue={visibleFilterSets[selectedFilterSetIndex || 0]}
              placeholder='Preset Filter Sets'
            />
            {/* <i className="far fa-save filter-set-button mx-2 flex-center" onClick={saveFilterSet}></i> */}
            <div className="filter-set-button mx-2 flex-center" onClick={saveFilterSet}><i className="far fa-save"></i></div>
          </div>

          <ul className="list-group small mx-1 my-1">
            {renderFilterInfo( tabs[selectedVariantTab].filters, false )}
            {/* {renderFilterInfo( Object.values(tabs[selectedVariantTab].filters).filter( t => t.visible===true), false )} */}
            {/* {renderFilterInfo( Object.keys(tabs[selectedVariantTab].filters).filter( t => tabs[selectedVariantTab].filters[t].visible===true), false )} */}
            {/* {renderFilterInfo(vanexFilterData, false )} */}
          </ul>

          {(Object.keys(globalTabFilters).length>0)
            ?
            <ul className="list-group small m-1">
              <label className="list-group-item fw-bold d-flex flex-row">
                <span className=" flex-grow-1">Global Filters:</span>
                  <React.Fragment>
                    <span className="fw-normal flex-grow-0 text-dblue cursor-pointer "
                    onClick={() => {setGlobalTabFilters({}); }} // setSelectedPathwayIds([])
                      >Clear <i className="fas fa-trash-alt text-primary"></i></span>
                  </React.Fragment>
              </label>
              {renderFilterInfo(globalTabFilters, true)}
            </ul>
          : null }

          {/* //* show unmodifiable filters! */}
          <ul className="list-group small mx-1 my-1">
            {/* <label className="list-group-item fw-bold d-flex flex-row">Tab Filters:</label> */}
              { Object.values(tabs[selectedVariantTab].filters).filter( t => t.editable===false).map( (item, i) => 
              <label className="list-group-item" key={i}><div className="form-check form-switch"><input className="form-check-input me-1" type="checkbox" name={item} checked="checked" disabled  readOnly />{item.getFilterDescr()}</div></label>
              )}
              {/* <label className="list-group-item"><div className="form-check form-switch"><input className="form-check-input me-1" type="checkbox" name="gnomAD" checked="checked" disabled  readOnly />{"gnomAD frq. < 0.001"}</div></label> */}
              { filterDescriptions.map( (item, i) => 
                <label className="list-group-item" key={i}><div className="form-check form-switch"><input className="form-check-input me-1" type="checkbox" name={item} checked="checked" disabled  readOnly />{item}</div></label>
              )}
          </ul>
          {/* <ul className="list-group small m-1">
              { filterDescriptions.map( (item, i) => 
              <label className="list-group-item" key={i}><div className="form-check form-switch"><input className="form-check-input me-1" type="checkbox" name={item} checked="checked" disabled  readOnly />{item}</div></label>
            )}
          </ul> */}

          {/* <div className="flex-center add-new-filter-wrapper mt-5 mb-3">
            <div className="add-new-filter flex-center" onClick={addNewFilter}><i className="fas fa-plus fa-lg"></i></div>
          </div> */}
        </div>
      </div>
    );
  }


  const renderNotesPanel = () => {
    let message = "No notes found.";
    if(currentVariantId===null){
      message = "No variant selected";
    }

    // let noteFilterFunction = t => (t['IS_SET_BY_OTHERS'] && !!t['VANEX_NOTES']);
    // if(selectedVariantTab==='TAB_SUMMARY' && !!tabs[selectedVariantTab] && !!tabs[selectedVariantTab].filters['MAIN_B'] && !!tabs[selectedVariantTab].filters['MAIN_B'].isApplied){
    //   noteFilterFunction = t => t['IS_SET_BY_OTHERS'];
    // }

    const variant = props.caseData[currentVariantId];
    // console.log(variant.VANEX_NOTES); //! fix this, it may need to get memoized? to have optimized performace
    return(
      <div className="card m-1 shadow-sm flex-grow-1 bg-white" style={{minWidth: '10rem'}}>
        <div className="variant-card-header bg-mid-blue text-light py-0 d-flex flex-row align-items-center">
          <span className="fs-5 fw-bold flex-grow-1">Notes</span>
          {/* <div className="">
            <label>
              <input className="form-check-input" type="checkbox" 
                onChange={(e) => setShowVaNexAutoNotes(e.target.checked)} 
                checked={showVaNexAutoNotes}
              /> Auto-Notes
            </label>
          </div> */}
        </div>
        {/* <h5 className="variant-card-header bg-light-blue">Notes</h5> */}
        {/* <h5 className="variant-card-header" style={{backgroundColor:'#b9def0'}}>Notes</h5> */}
        {/* <h5 className="variant-card-header" style={{backgroundColor:'#dcf3ff'}}>Notes</h5> */}
        <div className="d-flex flex-row flex-nowrap align-items-center justify-content-center">
          <div className="m-2 d-flex flex-column w-100">
          {(!!props.isLoadingNotes)
          ?
            <div className="d-flex flex-row mt-2">
              <span className="mx-3 spinner-border spinner-border-lg" role="status" aria-hidden="true"></span><span className="fs-4">Loading...</span>
            </div>
          :
          <>
            {/* { (!!variant && !!variant.VANEX_NOTES && (!!variant.VANEX_TAGS ||  !!variant.VANEX_NOTES['CURRENT_USER_NOTE'] || ( !!variant.VANEX_NOTES['ALL_USERS_NOTES'] && !!variant.VANEX_NOTES['ALL_USERS_NOTES'].length>0))) */}
            { (!!variant && !!variant.VANEX_NOTES )
            ?
              <>
                <div className="note-bubble d-flex flex-column flex-wrap">
                  <div className="fw-bold me-1 mt-1">
                    {(!!variant.VANEX_TAGS ? 
                      <i className="fas fa-check-circle fa-lg text-primary me-2"></i>
                    : null)}
                    {props.userName}
                  </div>
                  <EditableTextArea 
                    value={variant.VANEX_NOTES['CURRENT_USER_NOTE']} 
                    updateTextAreaValue={(value)=> {
                      if(!!props.updateVariantTableData){ 
                        setShouldBlockNavigation(true);
                        props.updateVariantTableData(variant.ROW_INDEX, 'VANEX_NOTES', {
                          ...variant.VANEX_NOTES,
                          CURRENT_USER_NOTE: value, 
                          UPDATED_AT: new Date() 
                          // ALL_USERS_NOTES: variant.VANEX_NOTES['ALL_USERS_NOTES']
                        });
                      } else {toast.error('Cannot update this value!')}
                      if(isAutoSavingNotes && (autoSaveNotesCounter < autoSaveNotesInterval) ){
                        setAutoSaveNotesCounter(autoSaveNotesCounter + 1);
                      }
                    }}
                  />
                  {/* {(!!variant.VANEX_NOTES['UPDATED_AT']) ? <hr className="m-1 p-0"/> : null} */}
                  <div className="small text-end">{variant.VANEX_NOTES['UPDATED_AT'] && new Date(variant.VANEX_NOTES['UPDATED_AT']).toLocaleString([], {year: 'numeric', month: 'numeric', day: 'numeric', hour: '2-digit', minute:'2-digit', hour12: true})}</div>
                </div>
                {showVaNexAutoNotes ? <div className="note-bubble d-flex flex-column flex-wrap">
                  <div className="fw-bold me-1 mt-1">
                    VaNex Auto-Notes
                  </div>
                  <div className="note-div px-1 display-linebreak">{VaNexAutoNotes.join('\n')}</div>
                </div> : null }
              {(!!variant.VANEX_NOTES['ALL_USERS_NOTES'] && !!variant.VANEX_NOTES['ALL_USERS_NOTES'].length>0 && showOtherUsersNotes)
              ?
                variant.VANEX_NOTES['ALL_USERS_NOTES'].filter(t => t['IS_SET_BY_OTHERS']).map( (note, index) => {
                  // variant.VANEX_NOTES['ALL_USERS_NOTES'].map( (note, index) => {
                  if (!note.VANEX_NOTES && !!note.VANEX_TAGS)
                    return(
                      <div className="d-flex flex-column flex-wrap align-items-center justify-content-center w-100 mb-1" key={index}>
                        <div className="fw-bold "><i className="fas fa-check-circle fa-lg text-primary my-1 mb-2 mx-2"></i>{note.USERNAME.split('::')[0]}{note.USERNAME.split('::').length > 1 ? <div className="text-end text-small">{note.USERNAME.split('::')[1]} </div>: '' }</div>
                      </div>
                    );
                  else if (!!note.VANEX_NOTES)
                    return (
                      // <div className="plus-border-radius border-light-blue mb-2 px-2 py-1 d-flex flex-row flex-wrap" key={index}>
                      <div className="note-bubble d-flex flex-column flex-wrap" key={index}>
                        <div className="fw-bold me-1 mt-1">
                          {(!!note.VANEX_TAGS ? 
                            <i className="fas fa-check-circle fa-lg text-primary me-2"></i>
                          : null)}
                          {note.USERNAME.split('::')[0]}{note.USERNAME.split('::').length > 1 ? <div className="text-end text-small">{note.USERNAME.split('::')[1]} </div>: '' }
                        </div>
                        <div className="note-div px-1">{note.VANEX_NOTES}</div>
                        {/* <hr className="m-1 p-0"/> */}
                        <div className="small text-end">{note.UPDATED_AT && new Date(note.UPDATED_AT).toLocaleString([], {year: 'numeric', month: 'numeric', day: 'numeric', hour: '2-digit', minute:'2-digit', hour12: true})}</div>
                      </div>
                    );
                  else return( <div key={index}>?</div> );
                })
              : null}
              </>
            :
              <span className="fs-6 text-center">{message}</span>
            }
            </>
          }
          </div>
        </div>
      </div>
    )
  }

  const handleToggleColumnVisibility = (e, columnId) => {
    let hiddenCols = [...hiddenColumnsIds];
    // TODO: check if this is in the array? this is fine now, but it might be good to check if the checkbox status matches th array!
    if(e.target.checked) {
      // console.log(columnId + ' removed from hiddenColumnsIds');
      hiddenCols = hiddenCols.filter(t => t!==columnId);
      if(columnOrder.indexOf(columnId) < 0) setColumnOrder([...columnOrder, columnId]);
    }
    else {
      // console.log(columnId + ' pushed to hiddenColumnsIds');
      hiddenCols.push(columnId);
    }
    setHiddenColumnsIds(hiddenCols);
  }

  const getColumnNameFromAccessor = (columnAccessor) => {
    //!!! let colDefinition = getParameterCaseInsensitive(variantFormatDefinition['column-definitions'],columnAccessor);
    // if(!!colDefinition){
    //   let colHeader= colDefinition['header'];
    //   if(colHeader){
    //     return colHeader;
    //   } else{
    //     return columnAccessor;
    //   }
    // } else {
    //   // console.log(colDefinition, columnAccessor);
      return columnAccessor;
    // }
  }

  const changeVisibleColumnsToDefaultForExport = () => {
    let defaultExportVisibleColumns = ['VANEX_TAGS','CHROMOSOME','LOC_START','LOC_END','P_GT','VANEX_NOTES','SEG_SIZE','CNV_TYPE','SEG_MEAN','NUM_MARK','GENE_SYMBOLS','OMIM_PHENOTYPES'];  
    let hiddenCols = [];
    Object.values(columnData).forEach(column => {
      if(!defaultExportVisibleColumns.includes(column.id) &&
          !( column.id.endsWith('.GT')) // && !(include_Alt_Percent && column.id.endsWith('_Alt_Percent'))
        ){
        hiddenCols.push(column.id);
      }
    });
    setHiddenColumnsIds(hiddenCols);
  }

  const [columnNameSearchValue, setColumnNameSearchValue] = useState('');

  const renderColumnList = () => {
    const sampleColNames = Object.keys(sampleColumns).map(i => i);
    let columnList = Object.values(columnData).filter( t => t.id!=='SAMPLES' && t.id!=='ROW_INDEX' )
      .sort( (elA,elB) => {
        if(!sampleColNames.includes(elA.id) && sampleColNames.includes(elB.id)) return 1;
        if(sampleColNames.includes(elA.id) && !sampleColNames.includes(elB.id)) return -1;
        if(sampleColNames.includes(elA.id) && sampleColNames.includes(elB.id))
          return(sampleColNames.indexOf(elA.id) - sampleColNames.indexOf(elB.id));

        if(!columnOrder.includes(elA.id) && !columnOrder.includes(elB.id)) return 1;
        if(!columnOrder.includes(elA.id) && columnOrder.includes(elB.id)) return 1;
        if(columnOrder.includes(elA.id) && !columnOrder.includes(elB.id)) return -1;
        return(columnOrder.indexOf(elA.id) - columnOrder.indexOf(elB.id));
    });
    if(columnNameSearchValue!==undefined && columnNameSearchValue!==null && columnNameSearchValue.trim() !== ''){ //(columnNameSearchValue.length>0){
      columnList = columnList.filter(t => String(t['Header']).toLowerCase().includes(columnNameSearchValue.toLowerCase()));
    }
    return (
      <div className="absolute-panel scroll-div fw-normal p-2">
        <button type="button" className="btn btn-sm btn-outline-primary mx-4 my-1 px-3 py-0" onClick={changeVisibleColumnsToDefaultForExport}>Default export columns</button>
        <input className="w-100 mb-1" type="text" placeholder="Search Column Names" value={columnNameSearchValue} onChange={(e)=>setColumnNameSearchValue(e.target.value)}/>
        { columnList.map( (column, index) => (
            <div className="no-white-space-wrap" key={index}>
              { ( !!showPMFPrefix && !!sampleColumns[column.id] ?  
                ((!!getTypeOfColumnsInPMFList(column)) ? 
                  // <button type="button" className="btn btn-sm btn-outline-secondary m-0 ms-1 p-0 px-1" data-bs-toggle="modal" data-bs-target="#refForChangeSampleTypeModal">{column.sampleType}</button>
                  <button type="button" style={{minWidth:'2rem'}}
                    className="btn btn-sm btn-outline-secondary m-0 me-1 mb-1 p-0 px-1"
                    onClick={() => sampleTypeModal.show()}
                  >
                    {getTypeOfColumnsInPMFList(column)}
                  </button>
                : <span style={{marginRight:'2.25rem'}}></span>)
              : <></>)}
              <label>
                <input type="checkbox" className="me-1"
                  checked={!hiddenColumnsIds.includes(column.id)}
                  onChange={(e) => handleToggleColumnVisibility(e, column.id)}
                  disabled={(!hiddenColumnsIds.includes(column.id) && hiddenColumnsIds.length >= (Object.keys(columnData).length)-3)}
                />
                {column.Header}
              </label>
            </div>
        ))}
        {(columnNameSearchValue.length>0) ? 
          <div className="text-dblue cursor-pointer text-center" onClick={()=>setColumnNameSearchValue('')}>+ {Object.values(columnData).length - Object.values(columnList).length } unmatched (show all)</div>
        : null }
      </div>
    );
  }


  const [shouldBlockNavigation, setShouldBlockNavigation] = useState(false);
  useEffect(() => {
    if (shouldBlockNavigation) {
      window.onbeforeunload = () => true
    } else {
      window.onbeforeunload = undefined
    }
  });
  useEffect(() => {
    props.setShouldBlockNavigation(shouldBlockNavigation);
  }, [shouldBlockNavigation])


  const renderVariantTab = (tabId) => {
    // console.log(props.currentAnalysisInfo);
    if(!mainUseEffectsIsDone){
      return(<div className="variant-viewer-split-pane d-flex my-5 justify-content-center">
          <span className="mx-3 spinner-border" role="status" aria-hidden="true"></span>
          <span className="fs-3">Loading...</span>
        </div>)
    }

    // // if(tabId ==="TAB_ALL_CNV_CALLS_MOTHER" || tabId ==="TAB_ALL_CNV_CALLS_FATHER"){
    // if(tabId !=="TAB_SUMMARY" && tabId !=="TAB_ALL_CNV_CALLS_PROBAND" && tabId !=="TAB_ALL_CNV_CALLS_PROBAND_DENOVO" ){
    //   return(<div className="variant-viewer-split-pane mt-3 ms-5"><h4>coming soon!</h4></div>)
    // }

    return(
      <div className="variant-viewer-split-pane">
        <Prompt
          when={shouldBlockNavigation}
          message='You have unsaved changes, are you sure you want to leave?'
        />
        <SplitPane split="horizontal" minSize={50} maxSize={-50} defaultSize={412}>
          {/* <div className="variant-card-body p-0 m-1 d-flex flex-column show-overflow bg-white" style={{ minHeight:'12rem', maxHeight:'20rem'}}> */}
          <div className="show-overflow absolute-panel d-flex flex-column mb-1 bg-white">

            {/* <VariantTable
    //! fix this part 
              updateVariantTableData={() => console.log('ToBeFixed!')}
              getTabName={() => console.log('selectedVariantTab=TAB_ALL_CNV_CALLS!')}
              hiddenColumnsIds={hiddenColumnsIds}
              // PMFSampleColNames={Object.keys(sampleColumns).map(i => i)}
              PMFSampleColNames={getSampleColumnsProbandAtFirst()}
              setDataForFilterSelectionModal={setDataForFilterSelectionModal}
              columns={columnData}
              data={variantData}
            /> */}

            <VariantTable
              // setSortBy={props.setSortBy}
              // initialSortBy={props.initialSortBy}
              initialSortBy={initialSortBy}
              trigerExportPreparation={trigerExportPreparation}
              preparedDataFromVariantTable={(values) => {setPreparedDataFromVariantTable(values); setTrigerExportPreparation(false)}}
              updateVariantTableData={(variantIndex, columnId, value) => { 
                if(!!props.updateVariantTableData){ 
                  setShouldBlockNavigation(true);
                  props.updateVariantTableData(variantIndex, columnId, value);
                } else {toast.error('Cannot update this value!')}
                if(isAutoSavingNotes && (autoSaveNotesCounter < autoSaveNotesInterval) ){
                  setAutoSaveNotesCounter(autoSaveNotesCounter + 1);
                }
              }}
              getTabName={() => selectedVariantTab}
              // getCaseID={() => props.currentCaseInformation.CASE_ID}
              // sendFeedback={sendDenovoAssessment}
              setColumnsSpec={(colId, colWidth) => Object.values(columnData).find(t => t.id===colId).setColWidth(colWidth) }
              hiddenColumnsIds={hiddenColumnsIds}
              reportCurrentPageIndex={(pind) => setLatestTablePageIndex(pind)}
              initialPageIndex={latestTablePageIndex}
              setDataForFilterSelectionModal={setDataForFilterSelectionModal}
              // PMFSampleColNames={Object.keys(sampleColumns).map(i => i)}
              PMFSampleColNames={getSampleColumnsProbandAtFirst()}
              currentVariantId={currentVariantId} 
              displayVariantInfo={ (variantId) => setCurrentVariantId(variantId)}
              variantFilterObj={ {...tabs[selectedVariantTab].filters, ...globalTabFilters} }
              columns={columnData} data={variantData}
            />
          </div>
          {renderVariantInfo()}
        </SplitPane>
      </div>
    );
  }



  const renderFiltersAndColumnsTabs = () => {
    return(
      <Tabs>
        <TabList>
          <Tab><span>Filters</span></Tab>
          <Tab><span>Columns</span></Tab>
          {/* <Tab><span>Pathways</span></Tab> */}
        </TabList>
        <TabPanel>{renderFilterList()}</TabPanel>
        <TabPanel>{renderColumnList()}</TabPanel>
        {/* <TabPanel>{renderPathwayList()}</TabPanel> */}
      </Tabs>
    );
  }

  const onSelectedTabChange = (index, lastIndex, event) => {
    // console.log(event.target.innerText);
    if(!!refForCreatableSelect.current){
      refForCreatableSelect.current.state.value = null;
    }
    setLatestTablePageIndex(0);
    setCurrentVariantId(null);
    // setNotesForCurrentVariant([]);
    setSelectedVariantTab(Object.keys(tabs)[index]);
    setSelectedFilterSetIndex(null);
  }

  const isNumericColumn = (columnId) => {
    let tmpList = props.caseData.filter(t => t[columnId]!==null);
    if(!!tmpList[0]){
      if(tmpList[0][columnId]!==undefined && tmpList[0][columnId]!==null){
        return(typeof(tmpList[0][columnId])=='number');
      }
    }
    return false;
  }

  const review_code_to_text = (revCode, returnNullForNotFound=false, returnLowerCase=false) => {
    let tmpOption = Object.values(ReviewOptions).find(l => l.value===revCode);
    // let tmpOption = Object.values(ReviewOptions).find(l => String(l.value).toLowerCase() === String(revCode).toLowerCase());
    if(!!tmpOption && !!tmpOption.label){
      if(returnLowerCase)
        return(String(tmpOption.label).toLowerCase());
      else
        return(tmpOption.label);
    } else {
      return( (returnNullForNotFound ? null : '' ) );
    }
  }

  const setDataForFilterSelectionModal = (e, selectedColumn) => {
    // console.log("---------", selectedColumn);
    // console.log(isNumericColumn(selectedColumn.id));
    if(selectedColumn.id==='VANEX_TAGS'){
      toast.error('Cannot filter '+selectedColumn.Header);
      return;
    }
    setFilterSelectionTitle(`Filtering ${selectedColumn.Header}`);
    let initValues = { columnName:selectedColumn.id, value:'', valueIsList:false, separateValueListBy:' ' , minValue:'', maxValue:'', includeNullValues:true, selTerms:[], filterBy:"UserProvidedValue", selectAllStatus:UNCHECKED }

    // let initValues = { value: 'z', minValue: 0, maxValue:0 }
    // setFilterSelectionFormik(<Formik className="" enableReinitialize={true} initialValues={initValues}
    // onSubmit={(fields) => {
    //     console.log(fields);
    //     filterSelectionModal.hide();
    //   }}>
    //     {({ values, setFieldValue }) => (
    //     <Form id={}>
    //       {/* { console.log(values)} */}
    //       {/* <CustomerPopup
    //           showModal={showModal}
    //           close={() => toggleCustomerModal()}
    //           onSelect={data => onSelectCustomerHandler(data, setFieldValue)}
    //         /> */}
    //       <div className="modal-body">
    //         <Field className="form-control" type="text" name="minValue" placeholder="" aria-label=""/>
    //         <Field className="form-control" type="text" name="maxValue" placeholder="" aria-label=""/>
    //       </div>
    //     <div className="modal-footer ">
    //       <button className="btn btn-primary" type="submit" ><i className="fas fa-filter me-2"></i> Apply</button>
    //       <button type="button" className="btn btn-secondary" onClick={() => filterSelectionModal.hide()}>Cancel</button>
    //     </div>
    //     </Form>)}
    //   </Formik>);
    //   filterSelectionModal.show();
    // return;

    if(isNumericColumn(selectedColumn.id)){
      //? ------------------- filtering column with NUMERIC values  ---------------------------

      if (!!globalTabFilters[selectedColumn.id]){
        if (!!globalTabFilters[selectedColumn.id]["minValue"] && !!globalTabFilters[selectedColumn.id]["maxValue"]){
          initValues["minValue"] = globalTabFilters[selectedColumn.id]["minValue"];
          initValues["maxValue"] = globalTabFilters[selectedColumn.id]["maxValue"];
        }
      }

      const getFilterDescriptionValue = (minValue, maxValue, includeNullValues) =>{
        let hasMinValue = (!!minValue || minValue===0);
        let hasMaxValue = (!!maxValue || maxValue===0);
        let nullValueDesc = ( includeNullValues ? " (Include Blanks)" : "" )
        if( hasMinValue && !hasMaxValue)
          return(` >= "${minValue}"${nullValueDesc}`);
        if( !hasMinValue && hasMaxValue)
          return(` <= "${maxValue}"${nullValueDesc}`);
        if( !hasMinValue && !hasMaxValue)
          return(`${nullValueDesc}`);
        return(` = "${minValue} to ${maxValue}"`);
      }

      setFilterSelectionFormik(
        <Formik className="" enableReinitialize={true} initialValues={initValues} onSubmit={(fields) => {
          // console.log(fields);
          setGlobalTabFilters(
            prevGlobalTabFilters => ({
              ...prevGlobalTabFilters,
              [selectedColumn.id]: {
                columnId: selectedColumn.id,
                label: `${selectedColumn.Header}`,
                value: getFilterDescriptionValue(fields.minValue, fields.maxValue, fields.includeNullValues),
                minValue: fields.minValue,
                maxValue: fields.maxValue,
                operation: '=',
                visible: true,
                editable: true,  // tabFilter: false,
                getFilterDescr: function(){ return(this.label + this.value)},
                // getFilterDescr: function(){ return(this.label + ' ' + this.operation + ' ' + this.value); },
                filterFunction: function(){
                  let hasMinValue = (!!fields.minValue || fields.minValue===0);
                  let hasMaxValue = (!!fields.maxValue || fields.maxValue===0);
                  if( hasMinValue && !hasMaxValue)
                    return( (t) => ( (t[selectedColumn.id]!==null && t[selectedColumn.id]!==undefined) ? (t[selectedColumn.id] >= fields.minValue ) : ( fields.includeNullValues ? true : false) ) );
                  if( !hasMinValue && hasMaxValue)
                    return( (t) => ( (t[selectedColumn.id]!==null && t[selectedColumn.id]!==undefined) ? (t[selectedColumn.id] <= fields.maxValue ) : ( fields.includeNullValues ? true : false) ) );
                  if( !hasMinValue && !hasMaxValue)
                    return( (t) => ( (t[selectedColumn.id]!==null && t[selectedColumn.id]!==undefined) ? false : ( fields.includeNullValues ? true : false) ) );
                  return( (t) => ( (t[selectedColumn.id]!==null && t[selectedColumn.id]!==undefined) ? ( (t[selectedColumn.id] >= fields.minValue ) && (t[selectedColumn.id] <= fields.maxValue )) : ( fields.includeNullValues ? true : false) ) );
                },
                isApplied: true
              }
            })
          );
          filterSelectionModal.hide();
        }}>
          <Form>
          <div className="modal-body">
            <table className="">
              <tbody>
                <tr>
                  <td>
                    <label className=""><br/>{selectedColumn.Header}</label> 
                  </td>
                  <td>
                    <label className=""><br/><i className="fas fa-equals"></i></label> 
                  </td>
                  <td>
                    <label className="form-check-label">
                      Min
                      <Field className="form-control" type="text" name="minValue" placeholder="" aria-label=""/>
                    </label>
                  </td>
                  <td>
                    <label className="form-check-label">
                      Max
                      <Field className="form-control" type="text" name="maxValue" placeholder="" aria-label=""/>
                    </label>
                  </td>
                </tr>
              </tbody>
            </table>
            <label className="mt-2 w-100 d-flex flex-column ms-1 align-items-center">
              <div>
                <Field className="mx-1" type="checkbox" name="includeNullValues" placeholder="" aria-label=""/>
                Include Blanks
              </div>
            </label>
          </div>
          <div className="modal-footer ">
            <button className="btn btn-primary" type="submit" ><i className="fas fa-filter me-2"></i>Apply Filter</button>
            <button type="button" className="btn btn-secondary" onClick={() => filterSelectionModal.hide()}>Cancel</button>
          </div>
          </Form>
        </Formik>
      );
    }
    else {
      //? ------------------- filtering column with TEXT values ---------------------------
      
      if (!!globalTabFilters[selectedColumn.id]){
        // debugger;
        if (!!globalTabFilters[selectedColumn.id]["value"]){
          initValues["value"] = globalTabFilters[selectedColumn.id]["value"];
        }
        if (!!globalTabFilters[selectedColumn.id]["filterBy"]){
          initValues["filterBy"] = globalTabFilters[selectedColumn.id]["filterBy"];
        }
        if (!!globalTabFilters[selectedColumn.id]["selTerms"]){
          initValues["selTerms"] = globalTabFilters[selectedColumn.id]["selTerms"];
        }
      }

      //? ------------------- collect unique values in an array ---------------------------
      let tmpObj = {}
      let tmpval;
      // Object.values(props.caseData).forEach((variantRecord) => {
      Object.values(variantData).forEach((variantRecord) => {
        // tmpObj[variantRecord[selectedColumn.id]] = ((!!variantRecord[selectedColumn.id]) ? variantRecord[selectedColumn.id] : "__Blank__");
        if(selectedColumn.id==='VANEX_NOTES'){
          tmpObj[variantRecord[selectedColumn.id]['CURRENT_USER_NOTE']] = variantRecord[selectedColumn.id]['CURRENT_USER_NOTE'];
        } else if(selectedColumn.id==='VANEX_REVIEWS'){
          tmpObj[variantRecord[selectedColumn.id]['REVIEW_VALUE']] = null;
          tmpval = Object.values(ReviewOptions).find(l => l.value === variantRecord[selectedColumn.id]['REVIEW_VALUE']);
          // console.log(tmpval);
          if(!!tmpval && !!tmpval.label){
            tmpObj[variantRecord[selectedColumn.id]['REVIEW_VALUE']] = tmpval.label;
          }
        } else {
          tmpObj[variantRecord[selectedColumn.id]] = variantRecord[selectedColumn.id];
        }
      });
      let selColUniqueValues = Object.values(tmpObj).map( k => k).sort().sort( (elA,elB) => ( Number(!elA) - Number(!elB)) );
      // console.log(selColUniqueValues);

      setFilterSelectionFormik(
        <Formik className="" enableReinitialize={true} initialValues={initValues} onSubmit={(fields) => {
          //! Equals, Does not equal, Contains, Does not contain, Begins with, Ends with, 
          // console.log(fields);
          let operation = "contains";
          // let useSelTerms = fields.filterBy === 'SelectedTerms';
          let myFilterFunction;
          if(fields.filterBy === 'SelectedTerms' || fields.valueIsList===true){
            operation = "=";
            let selectedTerms;
            let multiValuesProvided = (fields.valueIsList===true && fields.filterBy!=='SelectedTerms');
            if(multiValuesProvided){
              // selectedTerms = fields.value.split(fields.separateValueListBy);
              selectedTerms = String(fields.value).toLowerCase().split(fields.separateValueListBy);
            } else {
              selectedTerms = fields.selTerms;
            }
            // let selectedTerms = fields.selTerms.map( (term) => {
            //   if (term==='__Blank__'){
            //     return(null);
            //   }
            //   else{
            //     return(term);
            //   }
            // });
            // let includeNullValuesInFilter = fields.selTerms.includes("__Blank__");
            let includeNullValuesInFilter = (fields.selTerms.includes(null) || fields.selTerms.includes(''));
            myFilterFunction = function(){
              //* if multi values are provided as a list use toLowerCase first before comparing! otherwise they need to match exactly (it is case sensitive)
              if(selectedColumn.id==='VANEX_NOTES'){
                if(multiValuesProvided)
                  return( (t) => ( (!!t[selectedColumn.id]) ? ( selectedTerms.indexOf(String(t[selectedColumn.id]['CURRENT_USER_NOTE']).toLowerCase()) !== -1) : includeNullValuesInFilter ) );
                else
                  return( (t) => ( (!!t[selectedColumn.id]) ? ( selectedTerms.indexOf(t[selectedColumn.id]['CURRENT_USER_NOTE']) !== -1) : includeNullValuesInFilter ) );
              } else if(selectedColumn.id==='VANEX_REVIEWS'){
                // if(fields.valueIsList===true)
                //   selectedTerms = String(fields.value).toLowerCase().split(fields.separateValueListBy);
                return( (t) => ( (!!t[selectedColumn.id]) ? ( selectedTerms.indexOf(review_code_to_text(t[selectedColumn.id]['REVIEW_VALUE'], true, multiValuesProvided )) !== -1) : includeNullValuesInFilter ) );
              } else { 
                if(multiValuesProvided)
                  return( (t) => ( (!!t[selectedColumn.id]) ? ( selectedTerms.indexOf(String(t[selectedColumn.id]).toLowerCase()) !== -1) : includeNullValuesInFilter ) );
                else
                  return( (t) => ( (!!t[selectedColumn.id]) ? ( selectedTerms.indexOf(t[selectedColumn.id]) !== -1) : includeNullValuesInFilter ) );
              }
            }
          } else {
            myFilterFunction = function(){
              if(selectedColumn.id==='VANEX_NOTES'){
                return( (t) => ( (!!t[selectedColumn.id]) ? String(t[selectedColumn.id]['CURRENT_USER_NOTE']).toLowerCase().includes(fields.value.toLowerCase()) : false ));
              } else if(selectedColumn.id==='VANEX_REVIEWS'){
                return( (t) => ( (!!t[selectedColumn.id]) ? String(review_code_to_text(t[selectedColumn.id]['REVIEW_VALUE'], false)).toLowerCase().includes(fields.value.toLowerCase()) : false ));
                // return( (t) => ( (!!t[selectedColumn.id]) ? false : false ));
              } else {
                return( (t) => ( (!!t[selectedColumn.id]) ? String(t[selectedColumn.id]).toLowerCase().includes(fields.value.toLowerCase()) : false ));
                // return( (t) => {
                //   if(!!t[selectedColumn.id])
                //     console.log(String(t[selectedColumn.id]));
                //   return(true)
                //   // return( (!!t[selectedColumn.id]) ? t[selectedColumn.id].toLowerCase().includes(fields.value.toLowerCase()) : false )
                // });
              }
            }
          }

          setGlobalTabFilters(
            prevGlobalTabFilters => ({
              ...prevGlobalTabFilters,
              [selectedColumn.id]: {
                columnId: selectedColumn.id,
                label: `${selectedColumn.Header}`,
                value: fields.value,
                operation: `${operation}`,
                visible: true,
                editable: true,  // tabFilter: false,
                selTerms: fields.selTerms,
                filterBy: fields.filterBy,
                getFilterDescr: function(){
                  let fieldValue = `"${this.value}"`;
                  if(this.filterBy === 'SelectedTerms'){
                    fieldValue = `[${this.selTerms.join('], [')}]`;
                    // if(this.selTerms.length > 3){fieldValue = "[...]";}
                    // return(`"${fieldValue}"`)
                  }
                  return(this.label + ' ' + this.operation + ' ' + fieldValue);
                },
                filterFunction: myFilterFunction,
                isApplied: true
              }
            })
          ); 

          filterSelectionModal.hide();
        }}>
          {({ errors, values, touched, setValues }) => (
            <Form>
            <div className="modal-body">
              <div className="d-flex flex-row w-100">
                <div className="d-flex flex-column flex-grow-1">
                  <label className="">
                    <Field name="filterBy" className="form-check-input me-2" type="radio" value="UserProvidedValue" placeholder="" aria-label=""/>
                    {selectedColumn.Header}<span className="fw-bold mx-1">Contains</span>
                  </label>
                  <label className="form-check-label flex-grow-1">
                    <Field className="form-control w-100" type="text" name="value" placeholder="" aria-label=""
                    onFocus={e => { values.filterBy ='UserProvidedValue'; }}
                    />
                  </label>
                </div>
                <label className="d-flex flex-row ms-1 align-items-center flex-grow-0">
                  <Field className="mx-1" name="valueIsList" type="checkbox" />
                  <div className={(values.valueIsList ? '' : 'text-muted')}>
                    multiple values <br/>separated by 
                    <Field className="mx-1" disabled={!values.valueIsList} name="separateValueListBy" type="text" style={{maxWidth:'1.5rem'}}/>
                  </div>
                </label>
              </div>
              <hr/>
              <label className="">
                <Field name="filterBy" className="form-check-input me-2" type="radio" value="SelectedTerms" placeholder="" aria-label=""/>
                  {selectedColumn.Header}<span className="fw-bold mx-1">matches</span>
              </label>
              <div className="ist-group list-group-flush border border-secondary border-1 m-1 show-overflow l" style={{maxHeight:'40vh'}}>
                <label className="list-group-item">
                  <IndeterminateCheckbox
                    className="form-check-input me-1"
                    name="select-all"
                    value={values.selectAllStatus}
                    onFocus={e => { values.filterBy ='SelectedTerms'; }}
                    onChange={e => {
                      let chboxStatus = INDETERMINATE;
                      let selectedTerms = [];
                      if (e.target.checked) {
                        selColUniqueValues.forEach( (term) => selectedTerms.push(term));
                        chboxStatus = CHECKED;
                      } else {
                        chboxStatus = UNCHECKED;
                      }
                      setValues({ ...values, 
                        selectAllStatus: chboxStatus,
                        selTerms: selectedTerms 
                      });
                    }}
                  />
                  Select All
                </label>
                <FieldArray
                  name="selTerms"
                  render={arrayHelpers => (
                    <React.Fragment>
                      {selColUniqueValues.map( (tag, ind) => (
                        <label className="list-group-item" key={ind}>
                          <input
                            className="form-check-input me-1"
                            type="checkbox"
                            name={(tag!==null && tag!==undefined && tag!=='') ? tag.toString() : "__Blank__"}
                            checked={values.selTerms.includes(tag)}
                            onFocus={e => { values.filterBy ='SelectedTerms'; }}
                            onChange={e => {
                              let chboxStatus = INDETERMINATE;
                              let selectedTerms = [...values.selTerms];
                              if(values.selTerms.length === 0){
                                chboxStatus = UNCHECKED;
                              }
                              if (e.target.checked) {
                                if(values.selTerms.length === 0){
                                  chboxStatus = INDETERMINATE;
                                }
                                if(selColUniqueValues.length === (values.selTerms.length+1) ){
                                  chboxStatus = CHECKED;
                                }
                                // arrayHelpers.push(tag);
                                selectedTerms.push(tag);
                              } else {
                                if(values.selTerms.length-1 === 0){
                                  chboxStatus = UNCHECKED;
                                }
                                const removeIndex = values.selTerms.indexOf(tag);
                                // arrayHelpers.remove(removeIndex);
                                // let removeIndex = selectedTerms.map(item => item.id).indexOf(tag);
                                ~removeIndex && selectedTerms.splice(removeIndex, 1);  //! <= this is a nice way of doing this: (removeIndex >= 0) && array.splice(removeIndex, 1);
                              }
                              setValues({ ...values, 
                                selectAllStatus: chboxStatus,
                                selTerms: selectedTerms 
                              });
                            }}
                          />
                          {/* <span>{ (typeof(tag)==='boolean' ? ( (tag) ? 'Checked' : 'Unchecked') : (!!tag ? tag : "__Blank__") )}</span> */}
                          {/* <span>{(!!tag) ? (typeof(tag)==='boolean' ? 'Checked' : tag ) : "__Blank__"}</span> */}
                          <span>{(tag!==null && tag!==undefined && tag!=='') ? tag : "__Blank__"}</span>
                        </label>
                      ))}
                    </React.Fragment>
                  )}
                />
              </div>
            </div>
            <div className="modal-footer ">
              <button className="btn btn-primary" type="submit" ><i className="fas fa-filter me-2"></i>Apply Filter</button>
              <button type="button" className="btn btn-secondary" onClick={() => filterSelectionModal.hide()}>Cancel</button>
            </div>
            </Form>)}
          </Formik>
      );
    }
    filterSelectionModal.show();
    return;
  }

  function handleSampleTypeChange(fields) {
    if(
      ((fields.Proband !== 'None')  && (fields.Mother !== 'None')  && (fields.Father !== 'None') &&
      (fields.Proband !== fields.Mother) && (fields.Mother !== fields.Father)  && (fields.Proband !== fields.Father) 
      // && (fields.Proband !== '')  && (fields.Mother !== '')  && (fields.Father !== '')
      )
    ||
      ((fields.Proband !== 'None')  && (fields.Mother !== 'None')  && (fields.Father === 'None') &&
      (fields.Proband !== fields.Mother) 
      )
    ||
      ((fields.Proband !== 'None')  && (fields.Mother === 'None')  && (fields.Father !== 'None') &&
      (fields.Proband !== fields.Father) 
      )
    ||
      ((fields.Proband !== 'None')  && (fields.Mother === 'None')  && (fields.Father === 'None')
      )
    ){
      setPMFSampleColNames([fields.Proband, fields.Mother, fields.Father]);
      const sampleColumnNames = Object.keys(sampleColumns).map(i => i);
      if(!!sampleColumnNames && sampleColumnNames.length>0){
        setInitialColumnData( prevColumnData => prevColumnData.map( colInfo => {
          // let colHeader=colInfo.Header;
          let colAccessor = colInfo.id;
          if(sampleColumnNames.includes(colInfo.id))
            return({...colInfo, Header: getTypeOfColumnsInPMFList(colInfo,false, true, [fields.Proband, fields.Mother, fields.Father]) + colInfo.id })
            // colHeader=getTypeOfColumnsInPMFList(colInfo,false, true, [fields.Proband, fields.Mother, fields.Father]) + colInfo.id;
          if( colAccessor.endsWith(".GT") || colAccessor.endsWith('_Alt_Percent')  || colAccessor.endsWith('_GQ') || colAccessor.endsWith('_AD') || colAccessor.endsWith('_RD') ||
              colAccessor.endsWith('_TD') || colAccessor.endsWith('_PL') || colAccessor.endsWith('_DP') || colAccessor.endsWith('_SB') || colAccessor.endsWith('_GT_RAW') )
            // colHeader=colAccessor;//`${getSampleLabel(colAccessor.slice(0,-3))}: ${colAccessor}`;
            return({...colInfo, Header: colAccessor});
          return(colInfo)
        }));
      }
      toast.success('Success!'); // toast.success('SUCCESS!! :-)\n\n' + JSON.stringify(fields, null, 4));
      setRefresh(prevState => !prevState);
      sampleTypeModal.hide();
    }
    else {
      toast.error("Not a valid combination!")
    }
  }


  //? --------------------------------------------- Main Render ----------------------------------
  // console.log("render...");
  // console.log(tabs);
  // console.log(selectedFilterSetIndex);



//   return (
//     <div className="">
//       <div className="variant-card-body p-0 m-1 d-flex flex-column show-overflow bg-white" style={{ minHeight:'12rem', maxHeight:'20rem'}}>
//         <VariantTable
//           // initialSortBy={props.initialSortBy}
// //! fix this part 
//           updateVariantTableData={() => console.log('ToBeFixed!')}
//           getTabName={() => console.log('selectedVariantTab=TAB_ALL!')}
//           // hiddenColumnsIds={hiddenColumnsIds}
//           // PMFSampleColNames={Object.keys(sampleColumns).map(i => i)}
//           // PMFSampleColNames={getSampleColumnsProbandAtFirst()}
//           columns={columnData}
//           data={props.caseData}
//         />
//       </div>
//     </div>
//   );


 


  return (
    <React.Fragment>
      <SplitPane className={" bottom-tab-panel " + ( (props.onlyShowOneTab) ? " plus-border-radius " : "" )}
        split="vertical" minSize={100} maxSize={-100} defaultSize={280} >
        {(!!props.currentCaseNotes) ?
          <div className="variant-viewer-split-pane">
            <SplitPane split="horizontal" minSize={50} maxSize={-50} defaultSize={400} >
              <div className="show-overflow absolute-panel d-flex flex-column mb-1 sidebar-splitpane-panel">
                {renderFiltersAndColumnsTabs()}
              </div>
              <div className="show-overflow absolute-panel d-flex flex-column mb-1 sidebar-splitpane-panel">
                {renderNotesPanel()}
              </div>
            </SplitPane>
          </div>
        :
          <div className="sidebar-splitpane-panel">
            {renderFiltersAndColumnsTabs()}
          </div>
        }
        <div className="sidebar-splitpane-panel absolute-panel">
          <Tabs defaultIndex={Object.keys(tabs).indexOf(selectedVariantTab)} onSelect={onSelectedTabChange} >
            <TabList style={{paddingRight:'7rem'}}>
              {Object.values(tabs).map( (tabName, index) => <Tab key={index}><span>{tabName.label}</span></Tab>)}
              <div className="tab-menu-button-group d-flex flex-row ps-1 pt-1 align-items-center " >
                {/* <Dropdown as={ButtonGroup} size="sm" className="m-0 p-0">
                  <Button variant=""  className="m-0 p-0 text-light">
                  
                  <div className="m-0 ms-1 p-0 px-1 tab-menu-button cursor-pointer" onClick={saveNotes}>
                      <i className="fas fa-file-alt fs-6"></i><span className="fs-6 fw-bold ms-1 p-0">Save Notes</span>
                      {(isSavingNotes) ? 
                      <div className="progress export-progressbar">
                        <div className="progress-bar progress-bar-striped progress-bar-animated bg-info" role="progressbar" style={{width:`${savingNotesProgressbarValue}%`}} aria-valuenow={savingNotesProgressbarValue} aria-valuemin="0" aria-valuemax="100"></div>
                      </div>
                      : null}
                    </div>

                  </Button>

                  <Dropdown.Toggle split variant="" className="text-light" id="dropdown-split-basic" />

                  <Dropdown.Menu>
                    <Dropdown.Item href="#/action-1">Action</Dropdown.Item>
                    <Dropdown.Item href="#/action-2">Another action</Dropdown.Item>
                    <Dropdown.Item href="#/action-3">Something else</Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown> */}
                {/* <span className="ms-1 " style={{cursor:'default'}}>Started at: <span className="fw-bold">{analysisStartedAt}</span></span> */}
                {(canSaveNotes)
                ?
                  <>
                    {/* <div className="m-0 ms-1 p-0 px-1">
                      <label className="fs-6" >
                        <input className="mx-1" type="checkbox" name="use1000separatorcheckbox"
                          onChange={(e) => {setUse1000Separator(e.target.checked)}}
                          checked={use1000Separator} 
                        />
                        Use 1000 Separator
                      </label>
                    </div> */}
                    <div className="m-0 ms-1 p-0 px-1 tab-menu-button cursor-pointer" onClick={saveNotes}>
                      {(isSavingNotes) ? 
                        <>
                          <span className="mx-2 spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                          {/* <i className="fas fa-circle fs-6"></i> */}
                          <span className="fs-6 fw-bold ms-1 p-0">Saving...</span>
                          <div className="progress export-progressbar">
                            <div className="progress-bar progress-bar-striped progress-bar-animated bg-info" role="progressbar" style={{width:`${savingNotesProgressbarValue}%`}} aria-valuenow={savingNotesProgressbarValue} aria-valuemin="0" aria-valuemax="100"></div>
                          </div>
                        </>
                      :
                        (numberOfNotesSaved!==null && numberOfNotesSaved!==undefined) ? 
                          <>
                            <i className="fas fa-check-double green-lighter fs-6"></i>
                            <span className="fs-6 fw-bold ms-1 p-0">{numberOfNotesSaved} Notes Saved!</span>
                            {/* // TODO: if added review to CNV, bring this message back! <span className="fs-6 fw-bold ms-1 p-0">{numberOfNotesSaved} Notes &amp; {numberOfReviewSaved} Review Saved!</span> */}
                          </>
                        :
                          <>
                            <i className="fas fa-file-alt fs-6"></i><span className="fs-6 fw-bold ms-1 p-0">Save Notes</span>
                          </>
                      }
                    </div>
                    <Dropdown align="end" onSelect={notesOptions}>
                      <Dropdown.Toggle variant="" id="notesOptions-dropdown" className="tab-menu-button dropdown-toggle m-0 p-0 py-2 px-1 d-flex flex-row align-items-center">
                      </Dropdown.Toggle>
                      <Dropdown.Menu className="export-menu m-0" >
                        {/* <Dropdown.Item as={() => (<div className=""><input type="checkbox" className="mx-2" checked={isAutoSavingNotes}  readOnly />Auto Save Notes</div>)
                        } eventKey="summary"></Dropdown.Item> */}
                        <Dropdown.Item as="button" eventKey="hideOtherUsersNotes"><div className=""><input type="checkbox" className="mx-2" checked={!showOtherUsersNotes}  readOnly />Hide Other Users' Notes</div></Dropdown.Item>
                        <Dropdown.Item as="button" eventKey="autoSavingNotes" ><div className=""><input type="checkbox" className="mx-2" checked={isAutoSavingNotes}  readOnly />Auto Save Notes</div></Dropdown.Item>
                        <Dropdown.Item as={() => (<div className={`ms-5 d-flex ${(!isAutoSavingNotes) ? 'text-muted' :'' }`}>
                          - every<input type="number" 
                            min="1" step="1" 
                            className="mx-2" style={{maxWidth:'2.5rem', maxHeight:'1.6rem'}}
                            disabled={!isAutoSavingNotes}
                            defaultValue={autoSaveNotesInterval}
                            onChange={e => setAutoSaveNotesInterval(e.target.value)}
                          />
                          </div>)
                        } eventKey="summary"></Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>
                  </>
                : null }
                <Dropdown align="end " onSelect={exportSnvAsXlsx}>
                  <Dropdown.Toggle variant="" id="export-dropdown" className="tab-menu-button m-0 ms-1 p-0 px-2 d-flex flex-row align-items-center">
                    <div>
                      <i className="fas fa-download fs-5"></i><span className="fs-6 fw-bold mx-1 p-0">Export</span>
                      {(isExporting) ? 
                      <div className="progress export-progressbar">
                        <div className="progress-bar progress-bar-striped progress-bar-animated bg-info" role="progressbar" style={{width:`${exportProgressbarValue}%`}} aria-valuenow={exportProgressbarValue} aria-valuemin="0" aria-valuemax="100"></div>
                      </div>
                      : null}
                    </div>
                  </Dropdown.Toggle>
                  <Dropdown.Menu className="export-menu m-0" >
                    <Dropdown.Item as="button" eventKey="clipboard">to Clipboard</Dropdown.Item>
                    <Dropdown.Item as="button" eventKey="summary">Summary Tab Only</Dropdown.Item>
                    {/* <Dropdown.Item as="button" eventKey="noOriginalData">Exclude 'All SNVs' Tab</Dropdown.Item>
                    <Dropdown.Item as="button" eventKey="all">Complete Dataset</Dropdown.Item> */}
                    {/* <Dropdown.Item as="button" eventKey="all" onClick={() => exportSnvAsXlsx('all')} >Complete Dataset</Dropdown.Item> */}
                  </Dropdown.Menu>
                </Dropdown>

                {/* <span onClick={exportSnvAsXlsx}>
                  <i className="fas fa-download fs-5"></i><span className="fs-5 fw-bold mx-1 p-0">Export</span>
                  {(isExporting) ? 
                  <div className="progress export-progressbar">
                    <div className="progress-bar progress-bar-striped progress-bar-animated bg-info" role="progressbar" style={{width:`${exportProgressbarValue}%`}} aria-valuenow={exportProgressbarValue} aria-valuemin="0" aria-valuemax="100"></div>
                  </div>
                  : null}
                </span> */}
              </div>
            </TabList>
            {Object.keys(tabs).map( (tabId, indx) => <TabPanel key={indx}>{renderVariantTab(tabId)}</TabPanel>)}
          </Tabs>
        </div>
      </SplitPane>
      {/* //? --------------------------------------------- Modal ---------------------------------- */}
      <div className="modal fade" ref={refForFilterSelectionModal} tabIndex="-1" aria-labelledby="refForFilterSelectionModal" aria-hidden="true">
        {/* <div className="modal-dialog modal-sm"> */}
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">{filterSelectionTitle}</h5>
              <button type="button" className="btn-close" onClick={() => filterSelectionModal.hide()} aria-label="Close"></button>
            </div>
            {filterSelectionFormik}
          </div>
        </div>
      </div>
      {/* END Modal */}

      {/* //? --------------------------------------------- SampleType Modal ---------------------------------- */}
      <div className="modal fade" ref={refForChangeSampleTypeModal} tabIndex="-1" aria-labelledby="changeSampleTypeLabel" aria-hidden="true">
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="changeSampleTypeLabel">Change Sample Types</h5>
              <button type="button" className="btn-close" onClick={() => sampleTypeModal.hide()}  aria-label="Close"></button>
            </div>
            <Formik className=""
              enableReinitialize={true}
              initialValues={{ Proband: PMFSampleColNames[0] || 'None', Mother: PMFSampleColNames[1] || 'None', Father: PMFSampleColNames[2] || 'None' }}
              onSubmit={handleSampleTypeChange}
            >
            {({ errors, values, touched, setValues, setFieldValue }) => {
              let selectOptions = Object.keys(sampleColumns).map(i => ({value: i, label:i}) );
              selectOptions=[...selectOptions,{value: 'None', label:'None'}];
              return(
                <Form>
                  <div className="modal-body d-flex justify-content-center ">

                    <table className="change-sample-type-table w-100">
                      <thead>
                        <tr>
                          <th className="">Sample Type</th>
                          <th className="w-100">Sample ID</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>
                            <label className="mx-3">Proband</label> 
                          </td>
                          <td className="d-flex">
                            <Select className="w-100" 
                              name="Proband"
                              options={selectOptions}
                              value={{value: values.Proband, label:values.Proband}}
                              onChange={selectedOption => setFieldValue('Proband', selectedOption.value)}
                            />
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <label className="mx-3">Mother</label> 
                          </td>
                          <td className="d-flex">
                            <Select className="w-100"
                              name="Mother"
                              options={selectOptions}
                              value={{value: values.Mother, label:values.Mother}}
                              onChange={selectedOption => setFieldValue('Mother', selectedOption.value)}
                            />
                          </td>
                        </tr>
                          <tr>
                            <td>
                              <label className="mx-3">Father</label> 
                            </td>
                            <td className="d-flex">
                              <Select className="w-100"
                                name="Father"
                                options={selectOptions}
                                value={{value: values.Father, label:values.Father}}
                                onChange={selectedOption => setFieldValue('Father', selectedOption.value)}
                              />
                            </td>
                          </tr>
                      </tbody>
                    </table>

                  </div>
                  <div className="modal-footer">
                    <button type="button" className="btn btn-secondary" onClick={() => sampleTypeModal.hide()}>Close</button>
                    <button className="btn btn-primary" type="submit" ><i className="fas fa-save me-2"></i> Save changes</button>
                  </div>
                </Form>
              )
            }}
            </Formik>
          </div>
        </div>
      </div>
      {/* END Modal */}
    </React.Fragment>
  );
}


export default MTViewer;